// GENERATED by legal-sweep-mx/build.mjs. Do not edit by hand: change the source and rebuild.
export const LEGAL = {
 "brand": "Exsportia",
 "other": "MySportia",
 "effective": {
  "en": "15 October 2026",
  "th": "15 ตุลาคม 2569 (ค.ศ. 2026)"
 },
 "version": "2.0",
 "hosts": [
  "vms.exsportia.com",
  "wba.exsportia.com"
 ],
 "paths": {
  "privacy": "/privacy",
  "terms": "/terms",
  "deletion": "/data-deletion",
  "thPrefix": "/th"
 },
 "aliases": {
  "privacy": [
   "/privacy-policy",
   "/policy"
  ],
  "terms": [
   "/terms-and-conditions"
  ]
 },
 "entity": {
  "en": "Education AI Group Co., Ltd.",
  "th": "บริษัท เอ็ดดูเคชั่น เอไอ กรุ๊ป จำกัด",
  "reg": "0845568020186",
  "officeEn": "2/1 Moo 6, Tambon Bo Phut, Amphoe Koh Samui, Surat Thani 84320, Thailand",
  "officeTh": "เลขที่ 2/1 หมู่ที่ 6 ตำบลบ่อผุด อำเภอเกาะสมุย จังหวัดสุราษฎร์ธานี 84320",
  "branchEn": "9/493 Soi Lad Pla Khao 78, Khwaeng Anusawari, Khet Bang Khen, Bangkok",
  "branchTh": "เลขที่ 9/493 ซอยลาดปลาเค้า 78 แขวงอนุสาวรีย์ เขตบางเขน กรุงเทพมหานคร",
  "email": "info@educationai.group",
  "groupSite": "https://educationai.group"
 },
 "footer": {
  "en": {
   "line": "Education AI Group Co., Ltd. · Reg. no. 0845568020186 · 2/1 Moo 6, Tambon Bo Phut, Amphoe Koh Samui, Surat Thani 84320, Thailand · info@educationai.group",
   "copyright": "© 2026 Education AI Group Co., Ltd. Registered in Thailand, company registration number 0845568020186. Registered office: 2/1 Moo 6, Tambon Bo Phut, Amphoe Koh Samui, Surat Thani 84320, Thailand. Branch office: 9/493 Soi Lad Pla Khao 78, Khwaeng Anusawari, Khet Bang Khen, Bangkok.",
   "privacy": "Privacy",
   "terms": "Terms",
   "deletion": "Data deletion"
  },
  "th": {
   "line": "บริษัท เอ็ดดูเคชั่น เอไอ กรุ๊ป จำกัด · เลขทะเบียน 0845568020186 · เลขที่ 2/1 หมู่ที่ 6 ตำบลบ่อผุด อำเภอเกาะสมุย จังหวัดสุราษฎร์ธานี 84320 · info@educationai.group",
   "copyright": "© 2569 บริษัท เอ็ดดูเคชั่น เอไอ กรุ๊ป จำกัด (Education AI Group Co., Ltd.) จดทะเบียนในประเทศไทย เลขทะเบียนนิติบุคคล 0845568020186 สำนักงานใหญ่: เลขที่ 2/1 หมู่ที่ 6 ตำบลบ่อผุด อำเภอเกาะสมุย จังหวัดสุราษฎร์ธานี 84320 สำนักงานสาขา: เลขที่ 9/493 ซอยลาดปลาเค้า 78 แขวงอนุสาวรีย์ เขตบางเขน กรุงเทพมหานคร",
   "privacy": "ความเป็นส่วนตัว",
   "terms": "ข้อกำหนด",
   "deletion": "การลบข้อมูล"
  }
 },
 "strings": {
  "en": {
   "checkoutAgree": "I agree to the [Exsportia Terms](/terms), the [Privacy policy](/privacy) and the venue's cancellation policy.",
   "signUpAgree": "By creating an account or signing in you agree to the [Terms](/terms) and the [Privacy policy](/privacy). You can [delete your data](/data-deletion) at any time."
  },
  "th": {
   "checkoutAgree": "ฉันยอมรับ[ข้อกำหนดของ Exsportia](/th/terms) [นโยบายความเป็นส่วนตัว](/th/privacy) และนโยบายการยกเลิกของสถานประกอบการ",
   "signUpAgree": "การสร้างบัญชีหรือลงชื่อเข้าใช้ถือว่าคุณยอมรับ[ข้อกำหนด](/th/terms) และ[นโยบายความเป็นส่วนตัว](/th/privacy) คุณ[ลบข้อมูล](/th/data-deletion)ของคุณได้ทุกเมื่อ"
  }
 },
 "content": {
  "en": {
   "privacy": {
    "title": "Privacy policy",
    "meta": "Education AI Group Co., Ltd. · Effective 15 October 2026 · Version 2.0, replacing the version of 30 June 2026",
    "lead": [
     {
      "t": "p",
      "x": "**In plain language.** Exsportia is booking and venue-management software for sports, fitness and wellness venues in Thailand. When you book with a venue, the venue is responsible for the records it keeps about you and we run them for it. We are responsible for your Exsportia account and sign-in, for keeping the Platform secure, and for the privacy rules on this page."
     },
     {
      "t": "p",
      "x": "We never sell personal data and we do not use it for advertising. We share it only with the venue you deal with and with the providers that run the service (section 10). You can delete your account yourself, straight away (section 15 and the [data deletion page](/data-deletion)). This page is also available in Thai: [อ่านเป็นภาษาไทย](/th/privacy)."
     }
    ],
    "sections": [
     {
      "id": "who",
      "h": "1. Who we are",
      "blocks": [
       {
        "t": "p",
        "x": "Exsportia is a brand of Education AI Group Co., Ltd. (บริษัท เอ็ดดูเคชั่น เอไอ กรุ๊ป จำกัด), a company registered in Thailand. The same booking and venue-management Platform is offered under two brands, MySportia and Exsportia, and this policy covers both. In this policy \"we\", \"us\" and \"our\" mean Education AI Group Co., Ltd., the only legal company behind Exsportia and MySportia."
       },
       {
        "t": "ul",
        "items": [
         "**Controller:** Education AI Group Co., Ltd.",
         "**Company registration number:** 0845568020186",
         "**Registered office:** 2/1 Moo 6, Tambon Bo Phut, Amphoe Koh Samui, Surat Thani 84320, Thailand",
         "**Branch office:** 9/493 Soi Lad Pla Khao 78, Khwaeng Anusawari, Khet Bang Khen, Bangkok",
         "**Privacy contact:** [info@educationai.group](mailto:info@educationai.group)"
        ]
       },
       {
        "t": "p",
        "x": "The Platform includes the websites, booking pages, back-office software, check-in app and mobile or web apps that carry the MySportia or Exsportia name, and our customer-support channels (together, the \"Platform\")."
       }
      ]
     },
     {
      "id": "roles",
      "h": "2. Our two roles",
      "blocks": [
       {
        "t": "p",
        "x": "Under Thailand's Personal Data Protection Act B.E. 2562 (2019) (\"PDPA\") we act in two roles."
       },
       {
        "t": "ul",
        "items": [
         "**We are the controller** of your account and sign-in details, of the information we need to run, secure and support the Platform, of payment references, and of our own business and sales records. We decide why and how that data is used.",
         "**We are the processor** of the records a venue keeps about its own customers and members: bookings, memberships, attendance, notes, forms and waivers, and messages between the venue and its customers. The venue (a gym, studio, club, coach or other business, a \"Venue\") is the controller of those records, decides why they are used, and must give you its own privacy notice. We handle them only on the Venue's instructions."
        ]
       },
       {
        "t": "p",
        "x": "If you ask us for something that concerns a record a Venue keeps, we pass your request to the Venue and help it answer (section 16)."
       }
      ]
     },
     {
      "id": "scope",
      "h": "3. What this policy covers",
      "blocks": [
       {
        "t": "p",
        "x": "vms.exsportia.com, wba.exsportia.com, the Exsportia apps and back office, the check-in app, our booking pages and the support channels of Exsportia. It applies to customers and players, parents and guardians, Venue owners and staff, coaches, website visitors, people who contact us, and people who book on behalf of someone else. It does not replace a Venue's own privacy notice for data the Venue controls."
       }
      ]
     },
     {
      "id": "collect",
      "h": "4. Personal data we collect",
      "blocks": [
       {
        "t": "table",
        "head": [
         "Category",
         "Examples"
        ],
        "rows": [
         [
          "Account and profile",
          "Name, email address, mobile number, password or sign-in details (if you use Google, what Google shares with us: name, email, profile picture), date of birth where a Venue needs it, language, profile photo"
         ],
         [
          "Bookings and participation",
          "Bookings, classes, memberships and passes, check-ins and attendance, cancellations, waiting lists, forms and waivers a Venue asks you to complete, notes you add"
         ],
         [
          "Venue and business data",
          "Business name, contact person, staff accounts and roles, venue details, services, prices, bank or payout details where needed, business documents"
         ],
         [
          "Payments and billing",
          "Payment reference, amount, status, refunds, invoice and tax details. Card details are entered with the payment provider (Opn Payments, Stripe or PayPal) and are not stored by us"
         ],
         [
          "Messages and support",
          "Messages between you and a Venue in the Platform, notices we send you, support emails and requests"
         ],
         [
          "AI assistant",
          "What a staff member types or says to the assistant and the venue records it looks up to answer (section 7)"
         ],
         [
          "Technical data",
          "IP address, browser and device type, operating system, app version, push-notification identifier, log records, approximate location from IP, pages viewed, error reports"
         ],
         [
          "Content you provide",
          "Photos, comments or other content you upload"
         ]
        ]
       },
       {
        "t": "p",
        "x": "Please do not give us sensitive personal data (health, biometric, religious, political or criminal-record information) unless a feature clearly asks for it. A Venue may ask for health or injury information in its own forms, and then the Venue is responsible for obtaining your consent. Where we process sensitive data for a Venue, we apply extra safeguards and rely on explicit consent."
       }
      ]
     },
     {
      "id": "sources",
      "h": "5. Where we get personal data",
      "blocks": [
       {
        "t": "p",
        "x": "From you; from the Venue you book with or work for; from another person who books or invites on your behalf, or a parent or guardian; from Google if you choose \"Continue with Google\"; from payment providers; from our technology providers; and automatically when you use the Platform."
       }
      ]
     },
     {
      "id": "why",
      "h": "6. Why we use personal data, and our legal grounds",
      "blocks": [
       {
        "t": "table",
        "head": [
         "Purpose",
         "What we do",
         "Legal ground (PDPA)"
        ],
        "rows": [
         [
          "Provide the Platform",
          "Create and manage accounts; take bookings, memberships and payments; run check-in; send booking confirmations, reminders, receipts and service notices; give support",
          "Performance of a contract and steps you request before a contract"
         ],
         [
          "Run, secure and improve the Platform",
          "Keep it working, prevent fraud and misuse, find and fix faults, produce aggregated statistics",
          "Our legitimate interests, where they are not overridden by your rights"
         ],
         [
          "Legal and accounting duties",
          "Keep accounting and tax records, answer lawful requests, deal with disputes and claims",
          "Legal obligation; legitimate interests"
         ],
         [
          "News and offers",
          "Send marketing from us or, with your permission, from a Venue. You can unsubscribe in the message or in your settings",
          "Your consent"
         ],
         [
          "Sensitive data a Venue asks for",
          "Only for the purpose the Venue gave you when it asked",
          "Your explicit consent, collected by the Venue"
         ]
        ]
       }
      ]
     },
     {
      "id": "ai",
      "h": "7. AI features",
      "blocks": [
       {
        "t": "p",
        "x": "Exsportia includes AI features. They use AI model providers (section 10) and are described here so that you know what is sent to them."
       },
       {
        "t": "ul",
        "items": [
         "**The back-office assistant** helps Venue staff look things up and do routine work. What the staff member types or says, and the Venue records the assistant needs to answer (for example a booking or a customer's name), are sent to Anthropic, which provides the language model. If the voice features are switched on, voice audio goes to OpenAI for transcription and the text of spoken replies goes to ElevenLabs. Conversation history can be deleted by the user in the assistant, and it is removed when the account is deleted. Customers do not talk to this assistant.",
         "**The Venue's messaging assistant** (section 8.6): the customer's message and conversation, as described there, are sent to Anthropic to write a reply."
        ]
       },
       {
        "t": "p",
        "x": "We do not use Venue Data, customers' messages or anything staff type to train models, and we do not permit our AI providers to. The providers process the data only to produce the answer. We send only what the question needs. AI output can be wrong: a Venue is responsible for what it switches on, and a person can always take over a conversation."
       }
      ]
     },
     {
      "id": "messaging",
      "switch": "MESSAGING_CHANNELS",
      "h": "8. Messaging channels (WhatsApp, Messenger, Instagram, Telegram, LINE)",
      "blocks": [
       {
        "t": "p",
        "x": "A Venue can connect its own WhatsApp Business account, Facebook Page, Instagram professional account, Telegram bot and LINE official account to Exsportia, so that its team can read and answer customers' messages in one shared inbox (Messages). Channels are made available to Venues in stages. This section applies from the moment a Venue connects a channel, and to nothing before that. The practical steps to disconnect a channel or to ask for deletion are on our [data deletion page](/data-deletion)."
       },
       {
        "t": "h3",
        "x": "8.1 Our roles"
       },
       {
        "t": "ul",
        "items": [
         "The Venue is the **controller** of the messages it sends and receives through a channel, and of the customer details in them. It decides why they are used and must give its customers its own privacy notice.",
         "Education AI Group Co., Ltd. is the **processor** of those messages. We handle them only to run the inbox on the Venue's documented instructions.",
         "We are the **controller** of the details of the staff member who connects a channel (name, work email and, where a Venue authorises the connection by logging in with Meta, the technical identifier Meta gives our app for that person), and of the connection records we need to run the service securely (which account is connected, its status, when it was connected and disconnected, delivery and error records)."
        ]
       },
       {
        "t": "h3",
        "x": "8.2 How a channel is connected"
       },
       {
        "t": "p",
        "x": "Only the owner of the Venue account can connect or disconnect a channel (Settings, then Channels). The Venue enters the credentials of its own account or app with the provider (for example a Meta app's access token and app secret, or a Telegram bot token), or authorises the connection through a login window of Meta, which shows what the app may do and lets the Venue choose which accounts to share. We check that the credentials work with a read-only request to the provider, and we set up delivery of notifications where the provider allows it."
       },
       {
        "t": "h3",
        "x": "8.3 What we receive and store"
       },
       {
        "t": "ul",
        "items": [
         "**Messages:** the text of each message a customer sends to the Venue's account and each reply sent from it, with the time and, where the provider reports one, a delivery failure. Photos, videos, voice messages, files and stickers are not stored: they appear in the inbox as a short placeholder such as [photo], with the caption if there is one.",
         "**Sender identifiers:** the WhatsApp phone number; the Messenger page-scoped ID; the Instagram-scoped ID; the Telegram chat ID or LINE user ID; and the display name, username and language where the provider supplies them. A Venue's staff can link a conversation to a customer record; from then on later messages from that sender on that channel appear in that customer's thread.",
         "**Connection data:** the identifiers of the Venue's WhatsApp Business Account, phone number, Facebook Page, Instagram account, Telegram bot or LINE account; the access credentials (token and app secret); the connection's status; and when it was connected and disconnected.",
         "**Technical records:** delivery and error records, kept for security and fault-finding. We do not keep a copy of the provider's raw notification."
        ]
       },
       {
        "t": "h3",
        "x": "8.4 What we do not do"
       },
       {
        "t": "p",
        "x": "We do not sell this data. We do not use it for advertising. We do not use customers' messages to build profiles, for our own marketing, or to train or evaluate machine-learning models, and we do not permit our providers to. We do not read a Venue's messages except where the Venue asks us for support, where it is needed to keep the service secure, or where the law requires it. We do not message a Venue's customers on our own account through a channel: what goes out is written by the Venue's staff or, where the Venue has switched it on, by the Venue's messaging assistant."
       },
       {
        "t": "h3",
        "x": "8.5 Why we use it"
       },
       {
        "t": "p",
        "x": "To receive messages and show them in the Venue's shared inbox; to send the replies its staff write; to run the Venue's automated assistant if it switches one on; to keep the connection working and secure; to show delivery failures; and to meet our legal duties. For customers' messages the Venue's own legal basis applies (usually the customer's request or the contract with the Venue). For the connecting staff member's details and the connection records our basis is our contract with the Venue (section 24(3) PDPA) and our legitimate interest in security (section 24(5) PDPA)."
       },
       {
        "t": "h3",
        "x": "8.6 The optional AI messaging assistant"
       },
       {
        "t": "p",
        "x": "A Venue can switch on an assistant that answers customers' messages for it. It is off until the Venue turns it on, the Venue sets its greeting, rules and what it may do, and it hands the conversation to a person when it should or when a person takes over. To write a reply, the customer's message, the recent messages of that conversation, the Venue's rules and FAQ, and, for a customer linked to a customer record, the booking information about that customer needed to answer are sent to our AI provider (Anthropic, section 10). The provider processes them only to produce the reply. The Venue is responsible for telling its customers that an automated assistant may reply."
       },
       {
        "t": "h3",
        "x": "8.7 What Meta and the other providers do"
       },
       {
        "t": "p",
        "x": "WhatsApp, Messenger and Instagram are services of Meta Platforms; Telegram and LINE are services of their own providers. Messages travel through the provider's systems, and the provider processes data on its own services under its own terms and privacy policy (for Meta: facebook.com/privacy/policy), as an independent controller of that processing. Meta's charges for WhatsApp messaging are made by Meta to the Venue, not through us."
       },
       {
        "t": "h3",
        "x": "8.8 Security"
       },
       {
        "t": "p",
        "x": "Access tokens, app secrets and other credentials are stored encrypted in a secret store (Google Cloud), are never shown to Venue staff, and are never returned to the browser after the Venue submits them. Notifications from Meta and LINE are checked against a cryptographic signature, and Telegram's against a secret, before we act on them. Messages are stored in the Venue's own area of the database and access is limited by role and venue, so that a Venue's staff see only that Venue's messages."
       },
       {
        "t": "h3",
        "x": "8.9 Retention and deletion"
       },
       {
        "t": "ul",
        "items": [
         "**Access credentials:** deleted at once when the Venue disconnects the channel, and replaced (the old ones deleted) when it reconnects. If a provider stops accepting a credential, the connection shows that it needs attention and asks the Venue to reconnect; the credential stays until the Venue reconnects or disconnects.",
         "**Messages and the contact records created from them:** kept while the Venue's account is active, because they are the Venue's records, and deleted or anonymised when the Venue closes its account or instructs deletion, or when a person asks (8.10). The automatic deletion routines described on the data deletion page do not yet cover messages received through a channel or the contact records created from them. Until they do, we delete or anonymise them by hand: within 30 days after the grace period ends on a venue closure, and within 30 days of a request in other cases. We confirm in writing what was done.",
         "**Technical records:** the log periods in section 13.",
         "**Kept:** accounting entries (section 13) and a short record that a connection existed and was removed, because the law requires it or to keep the service secure."
        ]
       },
       {
        "t": "h3",
        "x": "8.10 Your rights, and how to have this data deleted"
       },
       {
        "t": "p",
        "x": "If you wrote to a Venue, ask the Venue first: it is the controller. You can also email [info@educationai.group](mailto:info@educationai.group) with \"Data deletion\" or \"Privacy request\" and the Venue, channel and dates involved. We pass the request to the Venue and, where we can lawfully delete as its processor, we do. We answer within 30 days. Section 16 describes your rights, and the [data deletion page](/data-deletion) describes each route step by step. Exsportia does not receive an automatic notice when you remove an app in Facebook or Instagram, so if you did and want us to delete what we hold, email us."
       },
       {
        "t": "h3",
        "x": "8.11 Transfers, children and cookies"
       },
       {
        "t": "p",
        "x": "Messages pass through the providers' systems, and our own hosting and sub-processors are outside Thailand: see section 11. Customers who message a Venue are normally adults; the Platform is not designed for messaging children directly, and we do not knowingly collect messages directly from children. A Venue that messages a minor must have the authority of the person with parental responsibility, as sections 19 and 20 of the PDPA require. Connecting a channel sets no cookie on any MySportia or Exsportia site."
       }
      ]
     },
     {
      "id": "meta",
      "h": "9. Facebook, Meta and Google",
      "blocks": [
       {
        "t": "p",
        "x": "You cannot sign in to Exsportia with Facebook, and the Exsportia apps and back office do not load the Meta (Facebook) Pixel or any Facebook plug-in. A Venue owner who connects a Meta messaging channel (section 8) may authorise it through Meta's own login window; that is the only place Meta's login appears. Our marketing website exsportia.com uses a cookie banner. If you accept marketing cookies there, it may load the Meta Pixel to measure our advertising; if you decline, it does not, and you can change your choice at any time through the banner settings. The Platform offers \"Continue with Google\": if you choose it, Google tells us your name, email address and profile picture, and Google handles your data under its own privacy policy. A Venue may link to its own Facebook or Instagram page; following that link takes you to Meta, which has its own policy."
       }
      ]
     },
     {
      "id": "share",
      "h": "10. When we share personal data, and our sub-processors",
      "blocks": [
       {
        "t": "p",
        "x": "We do not sell personal data. We share it only where needed for the purposes above:"
       },
       {
        "t": "ul",
        "items": [
         "with the Venue you book with or work for, so that it can run its service;",
         "with other participants only where a feature needs it (for example a team list or invitation), limited to basic details;",
         "with payment providers, banks and fraud-prevention services;",
         "with the providers in the table below, which process data for us under contract;",
         "with authorities, courts, insurers and advisers where the law requires or to protect rights and safety;",
         "with a buyer or successor of Education AI Group Co., Ltd. if the business is reorganised or sold, under confidentiality."
        ]
       },
       {
        "t": "h3",
        "x": "Our sub-processors"
       },
       {
        "t": "table",
        "head": [
         "Provider",
         "What for",
         "Personal data involved"
        ],
        "rows": [
         [
          "Google Cloud / Firebase (Google LLC)",
          "Our database, sign-in (Firebase Authentication, including \"Continue with Google\"), file storage and the servers that run the Platform",
          "Account, profile, booking, membership, message and venue records; uploaded files"
         ],
         [
          "Amazon Web Services",
          "Hosting of our websites and web apps",
          "Technical request data (IP address, browser)"
         ],
         [
          "Opn Payments (formerly Omise)",
          "Card and PromptPay payments where a venue uses it. We do not see or store full card numbers",
          "Name, email, amount, payment reference"
         ],
         [
          "Stripe",
          "Card payments where a venue uses it. We do not see or store full card numbers",
          "Name, email, amount, payment reference"
         ],
         [
          "PayPal",
          "Payments where a venue uses it",
          "Name, email, amount, payment reference"
         ],
         [
          "OneSignal",
          "Push notifications to your phone or browser (booking reminders and notices)",
          "A device identifier linked to your account"
         ],
         [
          "Vonage",
          "SMS messages (for example sign-in codes and booking notices)",
          "Mobile number and the text of the message"
         ],
         [
          "Resend and Google Workspace (Gmail)",
          "Sending our email (receipts, booking confirmations, invitations, notices)",
          "Name, email address and the text of the email"
         ],
         [
          "Algolia",
          "Search for venues, classes and, in the back office, people",
          "Names and listing details that appear in search"
         ],
         [
          "Cloudinary",
          "Storing and resizing images (venue photos, profile pictures)",
          "Images you or a venue upload"
         ],
         [
          "Intuit QuickBooks",
          "Accounting, only where a venue or we connect it",
          "Customer name, invoice and payment details"
         ],
         [
          "Google Calendar",
          "Calendar sync, only if a staff member switches it on",
          "Booking times and titles for that staff member"
         ],
         [
          "Meta Platforms (WhatsApp, Messenger, Instagram)",
          "The channels themselves, only if a Venue connects them (section 8)",
          "Messages sent and received through the Venue's accounts and the sender identifiers that come with them. Meta also processes this data for itself under its own terms (section 8)"
         ],
         [
          "Telegram; LINE",
          "The Telegram and LINE channels, only if a Venue connects them (section 8)",
          "Messages sent and received through the Venue's bot or official account, with the sender's chat or user ID and display name"
         ],
         [
          "Anthropic",
          "AI model provider, only when the back-office assistant is used or a Venue switches on the messaging assistant (section 7)",
          "What the user types or asks and the venue records needed to answer; for the messaging assistant, the customer's message and recent conversation, the Venue's rules and the booking information needed to answer. Not used to train models"
         ],
         [
          "Cloudflare",
          "DNS, content delivery and security, and receiving and routing notifications from the messaging channels",
          "Network and request data, including IP addresses"
         ],
         [
          "OpenAI and ElevenLabs",
          "Voice input and spoken replies of the AI assistant, only if that feature is switched on (section 7)",
          "Voice audio and the text spoken"
         ],
         [
          "GoHighLevel",
          "Our sales and onboarding records for venues that contact us (business contact details only, not customers)",
          "Venue contact person name, email, phone, venue details"
         ],
         [
          "Sentry",
          "Error reports from our apps, only where switched on",
          "Technical error data (browser, page, error text)"
         ],
         [
          "Google Tag Manager",
          "Usage statistics for the back office (loaded in the back office only)",
          "Pages viewed and technical data"
         ]
        ]
       },
       {
        "t": "p",
        "x": "Venues get 30 days' notice by email or in the back office before we add or replace a provider that processes their data. Some providers are used only if a Venue switches the feature on."
       }
      ]
     },
     {
      "id": "transfers",
      "h": "11. International transfers",
      "blocks": [
       {
        "t": "p",
        "x": "Our providers may process data in Thailand and in other countries, including the United States and Singapore. When personal data leaves Thailand we rely on the safeguards in section 28 of the PDPA: an adequate level of protection in the destination, contractual protections with the provider, your consent where appropriate, or another lawful mechanism."
       }
      ]
     },
     {
      "id": "cookies",
      "h": "12. Cookies and similar technologies",
      "blocks": [
       {
        "t": "p",
        "x": "The Exsportia apps use a small number of things stored in your browser: your sign-in session, your language choice, favourites and a booking you have started. These are necessary for the Platform to work. The payment providers (Opn Payments, Stripe, PayPal) load their own scripts on the payment step to take your payment securely and prevent fraud. The back office also loads Google Tag Manager for usage statistics. We do not use advertising cookies in the Exsportia apps. You can clear stored data in your browser settings; if you block the necessary items you may be signed out and some features may not work."
       }
      ]
     },
     {
      "id": "retention",
      "h": "13. How long we keep personal data",
      "blocks": [
       {
        "t": "table",
        "head": [
         "Data",
         "How long"
        ],
        "rows": [
         [
          "Your account, profile, push identifier and sign-in",
          "While your account is open. Deleted straight away when you delete your account (section 15)"
         ],
         [
          "Messages and notification records about you",
          "While your account is open; deleted when you delete your account"
         ],
         [
          "Channel connections, and messages and contacts received through a channel (WhatsApp, Messenger, Instagram, Telegram, LINE)",
          "Access credentials are deleted at once when the Venue disconnects the channel. Messages and the contact records created from them are the Venue's records, kept while its account is active, and deleted or anonymised within 30 days after a venue closure or a request (section 8.9)"
         ],
         [
          "Records a Venue keeps about its customers and members",
          "As the Venue decides, while it uses the Platform; anonymised when you delete your account (the personal details are removed from them) and when a Venue closes"
         ],
         [
          "Bookings, payments, invoices and similar accounting records",
          "At least five years from the relevant accounting period or transaction, and longer where a tax authority, dispute or legal claim requires. After your account is deleted they stay without your contact details wherever the record can be kept without them"
         ],
         [
          "Proof that you asked us to delete, or stopped marketing",
          "A short record with no more personal data than needed, so we can show we did it and do not contact you again"
         ],
         [
          "Logs and security records",
          "A limited period suited to security and fault-finding"
         ]
        ]
       },
       {
        "t": "p",
        "x": "When data is no longer needed we delete, anonymise or aggregate it. Copies may remain in our hosting providers' backups until they are overwritten in the normal cycle; we do not restore a deleted account's data from them."
       }
      ]
     },
     {
      "id": "security",
      "h": "14. Security",
      "blocks": [
       {
        "t": "p",
        "x": "We use technical and organisational measures to protect personal data: access controls and role-based permissions, encrypted connections, secure service providers and monitoring. No online service is completely secure. If a personal-data breach occurs we investigate and act as the PDPA requires, including telling the Personal Data Protection Committee Office and the people affected where required."
       }
      ]
     },
     {
      "id": "deletion",
      "h": "15. Deleting your account and your data",
      "blocks": [
       {
        "t": "p",
        "x": "You can delete your Exsportia account yourself: sign in to the booking app, open your **Profile**, then **Delete Account**. Deletion is immediate and cannot be undone. In short: your sign-in is removed; your profile is wiped; your future bookings are cancelled; your messages, notification settings and device registrations are deleted; and the personal details are removed from the records Venues hold that are linked to your account. Accounting records stay as described in section 13. The [data deletion page](/data-deletion) lists exactly what is removed and what is kept, for customers, Venue owners and staff, and explains how to ask us by email."
       }
      ]
     },
     {
      "id": "rights",
      "h": "16. Your rights under the PDPA",
      "blocks": [
       {
        "t": "p",
        "x": "Subject to the law you may: withdraw consent; ask for access to and a copy of your data; ask us to correct it; ask us to delete, destroy or anonymise it; ask us to restrict its use; ask for it in a portable form; and object to processing based on legitimate interests or direct marketing. You may complain to the Personal Data Protection Committee Office of Thailand if you think your rights have been infringed."
       },
       {
        "t": "p",
        "x": "Email [info@educationai.group](mailto:info@educationai.group) with \"Privacy request\" and tell us the account email or phone number and which Venue, if any, is involved. We may ask for information to confirm who you are. We reply within 30 days. If your request is about a record a Venue controls, we pass it to the Venue and help it respond."
       }
      ]
     },
     {
      "id": "children",
      "h": "17. Children and minors",
      "blocks": [
       {
        "t": "p",
        "x": "Venues use the Platform for activities that include children. The Platform is not meant for a child under 13 to use alone: a parent or guardian should make the bookings and create the account. Where the law requires a parent's or guardian's consent for a minor's data, we ask for it, and a Venue that collects a child's data is responsible for having it."
       }
      ]
     },
     {
      "id": "language",
      "h": "18. Language",
      "blocks": [
       {
        "t": "p",
        "x": "This policy is published in English and Thai. If they differ, the English text applies, except that a Thai text that gives you more protection under the PDPA prevails to that extent."
       }
      ]
     },
     {
      "id": "changes",
      "h": "19. Changes to this policy",
      "blocks": [
       {
        "t": "p",
        "x": "We update this page when our services, providers or the law change, and change the date at the top. For material changes we also tell users in the Platform or by email."
       }
      ]
     },
     {
      "id": "contact",
      "h": "20. Contact us",
      "blocks": [
       {
        "t": "p",
        "x": "Education AI Group Co., Ltd., 2/1 Moo 6, Tambon Bo Phut, Amphoe Koh Samui, Surat Thani 84320, Thailand. Branch office: 9/493 Soi Lad Pla Khao 78, Khwaeng Anusawari, Khet Bang Khen, Bangkok. Company registration number 0845568020186. Email [info@educationai.group](mailto:info@educationai.group)."
       },
       {
        "t": "p",
        "x": "Read this together with the [Exsportia Terms](/terms)."
       }
      ]
     }
    ]
   },
   "terms": {
    "title": "Terms and conditions",
    "meta": "Education AI Group Co., Ltd. · Effective 15 October 2026 · Version 2.0, replacing the version of 30 June 2026",
    "lead": [
     {
      "t": "p",
      "x": "These terms govern your use of Exsportia. Please read them. By creating an account, making a booking or otherwise using Exsportia you agree to them. How we handle personal data is explained in our [Privacy policy](/privacy); you can delete your account at any time (see the [data deletion page](/data-deletion)). A Thai summary is at [อ่านสรุปภาษาไทย](/th/terms)."
     }
    ],
    "sections": [
     {
      "id": "who",
      "h": "1. Who we are",
      "blocks": [
       {
        "t": "p",
        "x": "Exsportia is a software and platform brand of Education AI Group Co., Ltd. (บริษัท เอ็ดดูเคชั่น เอไอ กรุ๊ป จำกัด), a company registered in Thailand with company registration number 0845568020186, registered office 2/1 Moo 6, Tambon Bo Phut, Amphoe Koh Samui, Surat Thani 84320, Thailand, and branch office 9/493 Soi Lad Pla Khao 78, Khwaeng Anusawari, Khet Bang Khen, Bangkok. We are the only legal company behind Exsportia and MySportia. Contact: [info@educationai.group](mailto:info@educationai.group). In these terms \"we\", \"us\" and \"our\" mean Education AI Group Co., Ltd.."
       },
       {
        "t": "p",
        "x": "Exsportia provides software that helps people discover, book and manage sports, fitness, wellness and activity services: web and mobile apps, booking pages and widgets, a back office for venues, and related support (the \"Platform\"). The same Platform is also offered as MySportia. People who book activities are \"Players\"; venues, coaches, clubs, organisers and other providers are \"Hosts\"; together \"Users\"."
       }
      ]
     },
     {
      "id": "accept",
      "h": "2. Acceptance and electronic agreement",
      "blocks": [
       {
        "t": "p",
        "x": "By accessing or using the Platform you confirm that you have read and agree to these terms and the Privacy policy. If you use the Platform for a business, you confirm you have authority to bind it. We may record your acceptance electronically (including the version and time), and electronic records may be used as evidence, as far as the law allows."
       },
       {
        "t": "p",
        "x": "Additional terms may apply to a particular booking, Host, promotion or payment method. They will be shown to you before or during the booking."
       }
      ]
     },
     {
      "id": "role",
      "h": "3. Our role",
      "blocks": [
       {
        "t": "p",
        "x": "Unless we say otherwise at checkout or in a written agreement, Exsportia is a technology platform and intermediary. Hosts, not Exsportia, are responsible for the activities, venues, products, services and content they offer. A booking creates a contract for the service between the Player and the Host, subject to the Host's displayed terms and mandatory law. When we take a payment, send a booking message, help with support or help with a refund, that does not make us the organiser or provider of the Host's service."
       }
      ]
     },
     {
      "id": "accounts",
      "h": "4. Accounts, accuracy and security",
      "blocks": [
       {
        "t": "ul",
        "items": [
         "Give accurate, current and complete information and keep your sign-in details confidential. You are responsible for activity under your account unless you tell us promptly about unauthorised use.",
         "Do not use false details, impersonate anyone, or share, sell or transfer your account.",
         "We may ask for information to verify identity, authority or payment details.",
         "We may suspend or restrict access where we reasonably believe there is fraud, misuse, a security risk, inaccurate information, a breach of these terms or a legal requirement."
        ]
       }
      ]
     },
     {
      "id": "bookings",
      "h": "5. Bookings, payments and confirmations",
      "blocks": [
       {
        "t": "p",
        "x": "A booking is confirmed only when the Platform or the Host clearly confirms it. Some bookings depend on Host approval, availability, minimum numbers, weather, safety or other conditions shown before you book. Prices, taxes, fees, deposits and cancellation rules should be shown before you pay, and the Host is responsible for their accuracy."
       },
       {
        "t": "p",
        "x": "Payments may be taken by us, an affiliated payment provider or a third-party processor such as Opn Payments, Stripe or PayPal. You authorise the provider to charge your chosen method for the amounts properly due. Where currency conversion applies, your bank or the provider may use its own rate and charges. When you pay, the checkout shows you these terms, the Privacy policy and the Host's cancellation policy, and you confirm that you accept them before the payment is made."
       }
      ]
     },
     {
      "id": "cancel",
      "h": "6. Cancellations, refunds and no-shows",
      "blocks": [
       {
        "t": "p",
        "x": "Each Host must publish a clear cancellation and refund policy for its services, and that policy applies to the booking unless mandatory consumer law gives you more. Use the booking tools in the Platform or contact the Host to cancel or ask for a refund. Where we processed the payment we may help administer a valid refund under the Host's policy, the law and the payment provider's rules. A Player who does not attend may not be entitled to a refund unless the Host's policy or the law says so."
       },
       {
        "t": "p",
        "x": "We may cancel, change or reschedule a booking where reasonably necessary for safety, legal compliance, Host unavailability, force majeure, an obvious pricing or listing error, suspected fraud or a technical fault, and we will explain how any refund is treated."
       }
      ]
     },
     {
      "id": "players",
      "h": "7. Rules for Players",
      "blocks": [
       {
        "t": "ul",
        "items": [
         "Use venues, facilities and equipment responsibly, follow the Host's reasonable rules and safety instructions, and respect staff and other participants.",
         "You decide whether an activity is suitable for your fitness, skill, health and insurance needs.",
         "Give the Host accurate information it asks for where lawful and necessary (health, safety, age).",
         "Do not damage or misuse property, and do not take part while under the influence of anything that makes taking part unsafe."
        ]
       }
      ]
     },
     {
      "id": "hosts",
      "h": "8. Rules for Hosts",
      "blocks": [
       {
        "t": "ul",
        "items": [
         "A Host is an independent provider, solely responsible for its venue, events, services, staff, content, pricing, taxes, licences, insurance, safety, cancellations, refunds and customer care.",
         "Give accurate, complete and up-to-date information, including availability, location, prices, restrictions and material safety information, and have the rights to the content you upload.",
         "Comply with consumer-protection, tax, employment, safety, licensing, privacy and advertising law. As the controller of its customers' records, a Host must give its customers a privacy notice and have a lawful basis for what it collects, including any health information it asks for.",
         "Do not list anything unsafe, misleading, discriminatory or unlawful."
        ]
       },
       {
        "t": "p",
        "x": "A Host's use of paid, payment, white-label, data-access or payout features may also be governed by a separate written agreement or pricing schedule; if they conflict, the written agreement prevails for those commercial matters."
       }
      ]
     },
     {
      "id": "fees",
      "h": "9. Host fees and payouts",
      "blocks": [
       {
        "t": "p",
        "x": "We may charge Hosts platform, subscription, transaction, commission, payment-processing, support or other fees where the fee has been disclosed or agreed. Fees, deductions, settlement timing and payout methods may be set out in an agreement, a pricing schedule, a dashboard notice or the payment provider's terms. Where a Host trades in a currency other than the settlement currency, conversion is done by the payment provider and we neither bear nor benefit from exchange-rate movement. We may withhold, delay or adjust payments where reasonably needed for refunds, chargebacks, disputes, fraud, legal duties, tax withholding or a breach, and we will explain material payout issues to the Host."
       }
      ]
     },
     {
      "id": "content",
      "h": "10. User content and reviews",
      "blocks": [
       {
        "t": "p",
        "x": "You keep ownership of what you upload. You give Education AI Group Co., Ltd. a non-exclusive, worldwide, royalty-free licence to host, store, display and use it as needed to run, improve, promote and provide the Platform. The licence ends when you delete the content, except where it has been shared with others, sits in backups, or must be kept for legal, security or record-keeping reasons. You confirm that you have the rights to what you provide. We may remove content that breaches these terms or the law."
       }
      ]
     },
     {
      "id": "prohibited",
      "h": "11. Prohibited use",
      "blocks": [
       {
        "t": "p",
        "x": "Do not use the Platform to break the law, infringe rights, commit fraud, send spam or mislead; harass, threaten or endanger anyone; upload malware or try to gain unauthorised access or disrupt the Platform; scrape or copy data by automated means without permission; reverse engineer it; collect other users' personal data except for an authorised booking or as the law and our Privacy policy allow; post unlawful or inappropriate content; or use it to build a competing product."
       }
      ]
     },
     {
      "id": "ip",
      "h": "12. Intellectual property",
      "blocks": [
       {
        "t": "p",
        "x": "The Platform, including software, designs, branding, logos, text and code, is owned by or licensed to Education AI Group Co., Ltd. and protected by law. We give you a limited, personal, non-exclusive, non-transferable, revocable licence to use it under these terms. You may not copy, modify, sell, sublicense or create derivative works from it unless the law allows or we agree in writing."
       }
      ]
     },
     {
      "id": "third",
      "h": "13. Third-party services",
      "blocks": [
       {
        "t": "p",
        "x": "The Platform links to or works with third-party services such as payment providers, Google sign-in, maps, email and SMS delivery, app stores and Host websites. They operate under their own terms and privacy policies, and we are not responsible for them."
       }
      ]
     },
     {
      "id": "messaging",
      "switch": "MESSAGING_CHANNELS",
      "h": "13A. Messaging channels",
      "blocks": [
       {
        "t": "p",
        "x": "**13A.1 What this clause covers.** The Platform lets a Host connect its own WhatsApp Business account, Facebook Page, Instagram professional account, Telegram bot and LINE official account (each a \"Channel\") so that its team can read and answer customers' messages in the Host's inbox and, if the Host switches it on, so that a messaging assistant can answer them. Channels are made available in stages. This clause applies to a Channel from the moment the Host connects it. Only the owner of the Host account can connect or disconnect a Channel."
       },
       {
        "t": "p",
        "x": "**13A.2 Roles.** The Host is the controller and we are the processor of the messages sent and received through a Channel and of the customer details in them. We are a controller in our own right only for the details of the staff member who connects a Channel and for the connection records (the accounts connected, status, times of connection and disconnection, delivery and error records), as the Privacy policy says."
       },
       {
        "t": "p",
        "x": "**13A.3 The providers are the Host's own.** Each Channel is provided to the Host by its provider (Meta Platforms for WhatsApp, Messenger and Instagram; Telegram; LINE) under the provider's own terms, which the Host accepts directly with the provider. We are not a party to them. The Host is responsible for:"
       },
       {
        "t": "ul",
        "items": [
         "(a) holding the accounts, apps and approvals that the provider requires, and keeping its credentials accurate and secret;",
         "(b) complying with the provider's terms and policies as they apply to its use, including the Meta Platform Terms, the WhatsApp Business Terms and messaging guidelines, and the Messenger and Instagram platform policies, including their rules on opt-in, on the 24-hour window for replying, on prohibited content and on unsolicited messages;",
         "(c) every fee the provider charges, which the provider bills to the Host and not through us;",
         "(d) having a lawful basis for messaging its customers and processing their messages, and giving them the privacy notice the law requires; and",
         "(e) disconnecting a Channel promptly when a person who knows its credentials leaves its staff."
        ]
       },
       {
        "t": "p",
        "x": "**13A.4 What we do.** We receive the provider's notifications and check their signature or secret, store the messages and sender identifiers, show them to the Host's authorised staff, and send the replies that the Host's staff (or its assistant) write. We store a Channel's access credentials encrypted, never display them to staff, and delete them when the Host disconnects the Channel. We do not sell messages, use them for advertising or our own marketing, or use them to train models. The Privacy policy (section 8) describes the data in more detail."
       },
       {
        "t": "p",
        "x": "**13A.5 The messaging assistant.** The assistant is optional and is off until the Host switches it on. The Host configures it. It produces replies with an AI model, which can be wrong. The Host is responsible for its configuration, for telling its customers that an automated assistant may reply, and for monitoring conversations and taking them over. Any charge for the assistant is stated in the account or the order before it applies."
       },
       {
        "t": "p",
        "x": "**13A.6 Limits.** A Channel depends on its provider. A provider may refuse, delay, limit, suspend or end a Channel, or change its rules (including the window after which a free-form reply is not allowed), and a message may fail or be delivered without our being able to confirm it. We give no assurance of delivery or availability through a Channel."
       },
       {
        "t": "p",
        "x": "**13A.7 Disconnection and deletion.** The Host may disconnect a Channel at any time. The credentials are then deleted at once. Messages already received remain the Host's records until deleted as the [data deletion page](/data-deletion) describes."
       },
       {
        "t": "p",
        "x": "**13A.8 People who message the Host.** A person who asks us to delete their messages is told to ask the Host first, and we handle the request as the Privacy policy (section 8.10) and the data deletion page describe."
       }
      ]
     },
     {
      "id": "ai",
      "h": "14. AI assistant",
      "blocks": [
       {
        "t": "p",
        "x": "The back office includes an AI assistant for Host staff, and a Host can switch on a messaging assistant (clause 13A.5). Their answers can be wrong and are not professional advice. The Host staff member who uses them is responsible for checking what they say and for what is done as a result. How AI features use data is described in section 7 of the Privacy policy."
       }
      ]
     },
     {
      "id": "privacy",
      "h": "15. Privacy",
      "blocks": [
       {
        "t": "p",
        "x": "Our [Privacy policy](/privacy) forms part of these terms. It explains how we, and where relevant Hosts, handle personal data, and how to delete your account and data: see the [data deletion page](/data-deletion)."
       }
      ]
     },
     {
      "id": "children",
      "h": "16. Children and minors",
      "blocks": [
       {
        "t": "p",
        "x": "The Platform is not meant for a child under 13 to use without a parent or guardian. A parent or guardian must make bookings or create accounts for a child who cannot lawfully enter a binding agreement or consent to the processing. Hosts are responsible for age, supervision, safeguarding and consent rules for their own activities."
       }
      ]
     },
     {
      "id": "disclaimers",
      "h": "17. Availability, disclaimers and assumption of risk",
      "blocks": [
       {
        "t": "p",
        "x": "We aim to keep the Platform available and accurate, but it is provided \"as is\" and \"as available\", and, as far as the law allows, we do not promise uninterrupted or error-free operation. Sports and fitness involve a risk of injury and loss. You decide whether to take part and should take medical advice and insurance where appropriate. Nothing in these terms excludes liability that cannot lawfully be excluded, including for fraud, intentional misconduct, gross negligence, or death or personal injury where the law does not allow exclusion."
       }
      ]
     },
     {
      "id": "liability",
      "h": "18. Limitation of liability",
      "blocks": [
       {
        "t": "p",
        "x": "As far as the law allows, Education AI Group Co., Ltd. and its directors, employees, contractors and affiliates are not liable for indirect, incidental, special or consequential loss, loss of profit, opportunity, goodwill or data, or business interruption arising from the Platform, a Host, an event, a venue, user content or a booking between a Player and a Host. Where we are liable to you for a claim arising directly from the Platform, our total liability will not exceed the greater of (a) what you paid us directly for the affected service in the 12 months before the event and (b) THB 5,000. This limit does not apply to liability that cannot lawfully be limited."
       }
      ]
     },
     {
      "id": "indemnity",
      "h": "19. Indemnity",
      "blocks": [
       {
        "t": "p",
        "x": "As far as the law allows, you will indemnify Education AI Group Co., Ltd. and its directors, employees, contractors and affiliates against claims, losses and costs arising from your breach of these terms, unlawful conduct, misuse of the Platform, infringement of another person's rights or content you provide, except to the extent caused by our own negligence, intentional misconduct or breach of law."
       }
      ]
     },
     {
      "id": "termination",
      "h": "20. Suspension, termination and account deletion",
      "blocks": [
       {
        "t": "p",
        "x": "You may stop using the Platform at any time. You can delete your account yourself (sign in to the booking app, open your **Profile**, then **Delete Account**), and Hosts can close a venue as described on the [data deletion page](/data-deletion). Deleting the app alone does not delete your account. We may suspend or end access, remove content, or cancel bookings where reasonably necessary if you breach these terms, create a safety or legal risk, are involved in suspected fraud or chargebacks, or the law requires; we act reasonably and, where practical, tell you why. Obligations that by nature should survive (payment, confidentiality, intellectual property, liability limits, indemnities, disputes and record retention) continue."
       }
      ]
     },
     {
      "id": "changes",
      "h": "21. Changes to the Platform or these terms",
      "blocks": [
       {
        "t": "p",
        "x": "We may change, suspend or discontinue features where reasonably necessary for operational, security, legal, technical or commercial reasons, and we may amend these terms. For material changes we give reasonable notice in the Platform, by email or by a dashboard notice. Continued use after the effective date means you accept the updated terms, where the law allows."
       }
      ]
     },
     {
      "id": "law",
      "h": "22. Governing law and disputes",
      "blocks": [
       {
        "t": "p",
        "x": "These terms are governed by the laws of the Kingdom of Thailand. Before bringing a formal claim, contact us at [info@educationai.group](mailto:info@educationai.group) and give us a reasonable opportunity to resolve the matter. Subject to mandatory consumer law, the courts of Thailand have jurisdiction."
       }
      ]
     },
     {
      "id": "general",
      "h": "23. General",
      "blocks": [
       {
        "t": "p",
        "x": "If a provision is unenforceable, the rest stays in effect. You may not assign your rights without our written consent; we may assign ours to an affiliate or successor. A failure to enforce a right is not a waiver. These terms, the Privacy policy, any Host terms that apply to you and any separate written agreement are the whole agreement on their subjects. If translated, the English version prevails as far as the law allows, unless a Thai version expressly says otherwise."
       }
      ]
     },
     {
      "id": "contact",
      "h": "24. Contact",
      "blocks": [
       {
        "t": "p",
        "x": "Education AI Group Co., Ltd., 2/1 Moo 6, Tambon Bo Phut, Amphoe Koh Samui, Surat Thani 84320, Thailand. Branch office: 9/493 Soi Lad Pla Khao 78, Khwaeng Anusawari, Khet Bang Khen, Bangkok. Company registration number 0845568020186. Email [info@educationai.group](mailto:info@educationai.group)."
       }
      ]
     }
    ]
   },
   "deletion": {
    "title": "How to delete your data",
    "meta": "Education AI Group Co., Ltd. · Effective 15 October 2026 · Version 2.0",
    "lead": [
     {
      "t": "p",
      "x": "Exsportia is a brand and Platform of Education AI Group Co., Ltd. (บริษัท เอ็ดดูเคชั่น เอไอ กรุ๊ป จำกัด), company registration number 0845568020186. The same Platform is offered as MySportia, and this page covers both. It explains how to have your data removed, including data that came from Meta (Facebook, Instagram, WhatsApp), Telegram or LINE. How we handle personal data in general is explained in our [Privacy policy](/privacy). Thai version: [ภาษาไทย](/th/data-deletion)."
     },
     {
      "t": "h3",
      "x": "The short version"
     },
     {
      "t": "ul",
      "items": [
       "**To remove a connected channel:** sign in as the venue owner, open **Settings**, then **Channels**, and click **Disconnect**. We delete the stored access token at once.",
       "**To delete your own account:** sign in to the booking app, open your **Profile**, then **Delete Account** (customers), or in the back office open your **Profile**, then **Delete my account** (staff). It takes effect at once.",
       "**To have other data deleted:** email [info@educationai.group](mailto:info@educationai.group). We reply within 30 days and tell you what was deleted and what was kept.",
       "Exsportia does not receive an automatic notice when you remove our app in Facebook or Instagram. If you did, or want us to delete anything we hold about you, email us."
      ]
     }
    ],
    "sections": [
     {
      "id": "who",
      "h": "1. Who this page is for",
      "blocks": [
       {
        "t": "ul",
        "items": [
         "A venue that connected a WhatsApp, Messenger, Instagram, Telegram or LINE account and wants to disconnect it or close its account (sections 3 and 4).",
         "A person who messaged a venue that uses the Platform and wants those messages deleted (section 5).",
         "A person who has a Exsportia or MySportia account, or who removed our app in Facebook or Instagram, or who simply wants us to delete what we hold about them (sections 6 and 7)."
        ]
       }
      ]
     },
     {
      "id": "roles",
      "h": "2. Who is responsible for what",
      "blocks": [
       {
        "t": "p",
        "x": "A venue that uses the Platform is the controller of its customers' messages and of the customer details in them: it decides why they are kept and for how long. Education AI Group Co., Ltd. is the venue's processor: we store the messages and show them in the venue's inbox on the venue's instructions."
       },
       {
        "t": "p",
        "x": "We are the controller of the account of the people who sign in (for example the venue owner and staff, and customers with an account), and of the connection records we need to run the service securely. Because of this, the right route depends on who you are. Sections 3 to 7 take you through it."
       }
      ]
     },
     {
      "id": "channels-disconnect",
      "switch": "MESSAGING_CHANNELS",
      "h": "3. You are a venue and want to disconnect a channel",
      "blocks": [
       {
        "t": "ol",
        "items": [
         "Sign in to your back office (the Exsportia back office at vms.exsportia.com) as the owner of the venue. Only the owner can connect or disconnect a channel.",
         "Open **Settings**, then **Channels**.",
         "Find the channel, click **Disconnect**, then confirm."
        ]
       },
       {
        "t": "p",
        "x": "**What happens straight away.** The access token and the other credentials we hold for that channel are deleted from our encrypted secret store. Where we set up delivery of notifications with the provider, we tell the provider to stop sending them (we leave it alone if another connection still uses the same Page or account). The channel shows as not connected, and any reply still waiting to be sent fails and is not sent later."
       },
       {
        "t": "p",
        "x": "**What stays.** Messages already received stay in your inbox history as your business records, until you ask us to delete them or you close your account (sections 4 and 8)."
       },
       {
        "t": "p",
        "x": "Also remove our app inside Meta, so that Meta stops sharing data with it. Open Meta Business Settings, then Integrations, find the app you used to connect the Platform and remove it. For a personal Facebook or Instagram login, use the Business integrations or Apps and websites settings of that account. Where you connected with your own Meta app, you can also delete that app in the Meta developer dashboard."
       }
      ]
     },
     {
      "id": "venue",
      "h": "4. You are a venue and want to close your account",
      "blocks": [
       {
        "t": "p",
        "x": "Closing a venue is done by email in this back office: write to [info@educationai.group](mailto:info@educationai.group) from the venue owner's account email and say which venue. We send a copy of the venue's data on request, then close the venue after a 14-day period in which you can change your mind, and delete or anonymise its records as in section 8. Within 30 days after the closing day we also delete or anonymise by hand the messages received through a channel and the contact records created from them, together with any channel credentials still held, and confirm in writing. Self-service closing is available in the MySportia back office and is not yet in this one."
       }
      ]
     },
     {
      "id": "messaged",
      "h": "5. You messaged a venue and want your messages deleted",
      "blocks": [
       {
        "t": "p",
        "x": "The venue decides what it keeps, so please ask the venue first. You can also email [info@educationai.group](mailto:info@educationai.group) with:"
       },
       {
        "t": "ul",
        "items": [
         "the venue you messaged;",
         "the channel and the account you wrote from (your WhatsApp number, Messenger name, Instagram handle, Telegram or LINE name);",
         "the approximate dates; and",
         "how to reach you. We may ask you to confirm that the account is yours, for example by writing to us from it."
        ]
       },
       {
        "t": "p",
        "x": "We pass your request to the venue. Where we can lawfully delete the messages as the venue's processor, we do so by hand and tell you. We reply within 30 days."
       }
      ]
     },
     {
      "id": "meta-removed",
      "switch": "MESSAGING_CHANNELS",
      "h": "6. You removed our app in Facebook or Instagram, or want us to delete what we hold about you",
      "blocks": [
       {
        "t": "p",
        "x": "Email [info@educationai.group](mailto:info@educationai.group) from the address on your account, or tell us the Facebook, Instagram or WhatsApp account concerned. Within 30 days we delete any Meta access token and any identifiers Meta gave us for you, mark any connection you made as disconnected, and tell you in plain words what was deleted and what was kept, and why."
       }
      ]
     },
     {
      "id": "account",
      "h": "7. You have a Exsportia or MySportia account",
      "blocks": [
       {
        "t": "h3",
        "x": "Customers"
       },
       {
        "t": "ol",
        "items": [
         "Sign in to the Exsportia booking app and open your **Profile**.",
         "Choose **Delete Account**.",
         "Read what will happen and confirm. The deletion cannot be undone."
        ]
       },
       {
        "t": "p",
        "x": "What happens at once, when you confirm:"
       },
       {
        "t": "ul",
        "items": [
         "Your sign-in is deleted. You cannot sign in with it again.",
         "Your profile is wiped: name, email, phone, date of birth, gender, address and ID details are removed or replaced, and your profile photo and uploaded files are deleted.",
         "Your future bookings are cancelled and you are taken off waiting lists.",
         "On every venue record linked to your account, the personal details (name, email, phone, birthday, address, photo, comments, emergency contact) are removed and the record shows as \"Deleted contact\".",
         "Your message threads, notification settings and device registrations are deleted.",
         "Your name and contact details are replaced by \"Deleted customer\" on your past bookings."
        ]
       },
       {
        "t": "p",
        "x": "If you cannot sign in, email [info@educationai.group](mailto:info@educationai.group) from the address on your account. Messages you exchanged with a venue through a channel belong to the venue's records and are covered by section 5."
       },
       {
        "t": "h3",
        "x": "Staff"
       },
       {
        "t": "ul",
        "items": [
         "**Remove a staff member from a venue:** the venue owner opens **Team** and removes the person. They lose access to that venue only. Their account and their other venues are not affected.",
         "**Delete your own staff account:** in the back office open your **Profile**, then **Delete my account**. Your staff access to every venue is removed, your calendar-sync connections and AI-assistant history are deleted, and your account is deleted as for customers above. If you are the only owner of a venue that is still open, close the venue first."
        ]
       },
       {
        "t": "h3",
        "x": "Records a venue created about you"
       },
       {
        "t": "p",
        "x": "A record the venue created about you without linking it to your account (for example a walk-in entered by staff) stays with the venue, because the venue is its controller. Ask the venue to delete it, or email us and we pass the request to the venue and help it answer within 30 days."
       }
      ]
     },
     {
      "id": "table",
      "h": "8. What we delete, and what we keep",
      "blocks": [
       {
        "t": "table",
        "head": [
         "Data",
         "What happens"
        ],
        "rows": [
         [
          "Access tokens and other channel credentials",
          "Deleted at once when the venue disconnects the channel, and on a closure or a deletion request. Replaced (the old one deleted) if the venue reconnects."
         ],
         [
          "Messages and conversation records",
          "Kept for the venue while its account is active (they are its records). Deleted or anonymised by hand on a venue closure (section 4), or on a request (sections 5 and 6), within 30 days. Messages of a customer who deletes their account are deleted with it (section 7)."
         ],
         [
          "Contact records from a channel (name, username, channel identifier)",
          "Same as messages."
         ],
         [
          "Customer account, profile, notifications and device registrations",
          "Deleted or wiped at once when the customer deletes the account (section 7)."
         ],
         [
          "Customer and member records held by a venue",
          "Personal details removed from the records linked to a deleted account; all contact records anonymised when a venue closes (section 4)."
         ],
         [
          "Accounting entries (bookings, payments, invoices, receipts)",
          "Kept for the period the law requires, which in Thailand is at least five years. These are statutory books. See the notes below."
         ],
         [
          "A short record that a connection existed and was removed; security and technical logs",
          "Kept only as long as needed for security and fault-finding, as the Privacy policy states."
         ],
         [
          "Backups",
          "Overwritten on the provider's ordinary backup cycle. We do not restore a deleted account's data from them."
         ]
        ]
       },
       {
        "t": "ul",
        "items": [
         "Bookings, payments, sales, invoices and similar accounting records are kept, because the law requires accounting records to be kept (in Thailand at least five years). When you delete your own account, your name and contact details on your past bookings are replaced by \"Deleted customer\" wherever the record can be kept without them; where an issued tax invoice has to show the buyer, it stays as issued.",
         "When a venue closes, its sales, bookings, passes sold, invoices, payments and payouts stay as they are, including the names and contact details copied onto them, for the same legal reason. The venue's own profile (name, address) is kept too.",
         "Records a venue created about you without linking them to your account stay with the venue (section 7).",
         "A short record that you asked for deletion, with no more personal data than needed, so we can show we did it and do not contact you again.",
         "Information we must keep to deal with a legal claim, a dispute, fraud or a security incident, for as long as that need lasts."
        ]
       },
       {
        "t": "p",
        "x": "We keep records needed to establish, exercise or defend a legal claim for as long as the claim is live. Everything else is deleted."
       }
      ]
     },
     {
      "id": "channels",
      "switch": "MESSAGING_CHANNELS",
      "h": "9. Meta (Facebook, Instagram, WhatsApp) data",
      "blocks": [
       {
        "t": "p",
        "x": "A venue can connect its own WhatsApp Business account, Facebook Page and Instagram professional account to Exsportia, so that its team can read and answer customer messages in one inbox."
       },
       {
        "t": "p",
        "x": "**What we receive from Meta:** the text of messages sent to the venue's account; the sender's WhatsApp phone number, Messenger page-scoped ID or Instagram-scoped ID, and the display name or username where Meta supplies it; the identifiers of the venue's WhatsApp Business Account, phone number, Facebook Page and Instagram account; the access token for the connection; and whether a reply was delivered or failed. Photos, videos, voice messages and files are not stored: they appear in the inbox as a short placeholder such as [photo]."
       },
       {
        "t": "p",
        "x": "**What we do with it:** show the messages to the venue's team, send the replies the team (or the venue's optional AI assistant) writes, and keep the connection working and secure. We do not sell it, use it for advertising, or use customers' messages for our own marketing or to train AI models."
       },
       {
        "t": "p",
        "x": "**How to delete it:** sections 3 to 6 above. You can also review and remove apps connected to your Facebook or Instagram account in Meta's Apps and websites or Business integrations settings. Meta handles data on its own services under its own privacy policy."
       }
      ]
     },
     {
      "id": "request",
      "h": "10. How to make a request, and what happens next",
      "blocks": [
       {
        "t": "ol",
        "items": [
         "Email [info@educationai.group](mailto:info@educationai.group) with the subject \"Data deletion\". Include what is described in section 5 or 6, and the venue and account concerned.",
         "We confirm that we received it, and may ask you to confirm who you are.",
         "Within 30 days we delete or anonymise what we can lawfully delete, pass on to the venue what only the venue can decide, and write to you saying what was deleted, what was kept and why."
        ]
       },
       {
        "t": "p",
        "x": "You can also complain to the Personal Data Protection Committee of Thailand."
       }
      ]
     },
     {
      "id": "contact",
      "h": "Contact",
      "blocks": [
       {
        "t": "p",
        "x": "Education AI Group Co., Ltd. (บริษัท เอ็ดดูเคชั่น เอไอ กรุ๊ป จำกัด), operating Exsportia and MySportia. Company registration number 0845568020186. Registered office: 2/1 Moo 6, Tambon Bo Phut, Amphoe Koh Samui, Surat Thani 84320, Thailand. Branch office: 9/493 Soi Lad Pla Khao 78, Khwaeng Anusawari, Khet Bang Khen, Bangkok. Privacy, data deletion and legal: [info@educationai.group](mailto:info@educationai.group)."
       }
      ]
     }
    ]
   }
  },
  "th": {
   "privacy": {
    "title": "นโยบายความเป็นส่วนตัว",
    "meta": "บริษัท เอ็ดดูเคชั่น เอไอ กรุ๊ป จำกัด · มีผลตั้งแต่วันที่ 15 ตุลาคม 2569 (ค.ศ. 2026) · เวอร์ชัน 2.0 · หากข้อความไม่ตรงกัน ให้ถือฉบับภาษาอังกฤษเป็นหลัก เว้นแต่ข้อความภาษาไทยให้ความคุ้มครองตาม PDPA มากกว่า",
    "lead": [
     {
      "t": "p",
      "x": "**สรุปโดยย่อ** Exsportia เป็นซอฟต์แวร์จองและบริหารจัดการสำหรับสถานประกอบการด้านกีฬา ฟิตเนส และสุขภาพในประเทศไทย เมื่อคุณจองกับสถานประกอบการ สถานประกอบการเป็นผู้รับผิดชอบระเบียนที่เก็บเกี่ยวกับคุณ และเราดำเนินการให้ ส่วนเรารับผิดชอบบัญชี Exsportia และการลงชื่อเข้าใช้ของคุณ ความปลอดภัยของแพลตฟอร์ม และกฎความเป็นส่วนตัวในหน้านี้"
     },
     {
      "t": "p",
      "x": "เราไม่ขายข้อมูลส่วนบุคคลและไม่ใช้เพื่อการโฆษณา เราแบ่งปันกับสถานประกอบการที่คุณใช้บริการและผู้ให้บริการที่ช่วยให้บริการทำงานเท่านั้น (ข้อ 10) คุณลบบัญชีของคุณเองได้ทันที (ข้อ 15 และ[หน้าการลบข้อมูล](/th/data-deletion)) หน้านี้มีฉบับภาษาอังกฤษที่ [Read in English](/privacy)"
     }
    ],
    "sections": [
     {
      "id": "who",
      "h": "1. เราคือใคร",
      "blocks": [
       {
        "t": "p",
        "x": "Exsportia เป็นแบรนด์ของ บริษัท เอ็ดดูเคชั่น เอไอ กรุ๊ป จำกัด (Education AI Group Co., Ltd.) บริษัทที่จดทะเบียนในประเทศไทย แพลตฟอร์มจองและบริหารจัดการสถานประกอบการเดียวกันให้บริการภายใต้สองแบรนด์ คือ MySportia และ Exsportia และนโยบายนี้ครอบคลุมทั้งสองแบรนด์ ในนโยบายนี้ “เรา” หมายถึง บริษัท เอ็ดดูเคชั่น เอไอ กรุ๊ป จำกัด ซึ่งเป็นนิติบุคคลเพียงรายเดียวที่อยู่เบื้องหลัง Exsportia และ MySportia"
       },
       {
        "t": "ul",
        "items": [
         "**ผู้ควบคุมข้อมูลส่วนบุคคล:** บริษัท เอ็ดดูเคชั่น เอไอ กรุ๊ป จำกัด",
         "**เลขทะเบียนนิติบุคคล:** 0845568020186",
         "**สำนักงานใหญ่:** เลขที่ 2/1 หมู่ที่ 6 ตำบลบ่อผุด อำเภอเกาะสมุย จังหวัดสุราษฎร์ธานี 84320",
         "**สำนักงานสาขา:** เลขที่ 9/493 ซอยลาดปลาเค้า 78 แขวงอนุสาวรีย์ เขตบางเขน กรุงเทพมหานคร",
         "**ติดต่อเรื่องความเป็นส่วนตัว:** [info@educationai.group](mailto:info@educationai.group)"
        ]
       },
       {
        "t": "p",
        "x": "แพลตฟอร์มรวมถึงเว็บไซต์ หน้าจอง ซอฟต์แวร์ระบบหลังบ้าน แอปเช็กอิน และแอปมือถือหรือเว็บที่ใช้ชื่อ MySportia หรือ Exsportia และช่องทางสนับสนุนลูกค้าของเรา (รวมเรียกว่า “แพลตฟอร์ม”)"
       }
      ]
     },
     {
      "id": "roles",
      "h": "2. บทบาทสองอย่างของเรา",
      "blocks": [
       {
        "t": "p",
        "x": "ภายใต้พระราชบัญญัติคุ้มครองข้อมูลส่วนบุคคล พ.ศ. 2562 (“PDPA”) เรามีสองบทบาท"
       },
       {
        "t": "ul",
        "items": [
         "**เราเป็นผู้ควบคุมข้อมูล** ของบัญชีและข้อมูลลงชื่อเข้าใช้ของคุณ ข้อมูลที่จำเป็นต่อการดำเนินงาน รักษาความปลอดภัย และสนับสนุนแพลตฟอร์ม รหัสอ้างอิงการชำระเงิน และบันทึกธุรกิจและการขายของเราเอง",
         "**เราเป็นผู้ประมวลผลข้อมูล** ของระเบียนที่สถานประกอบการเก็บเกี่ยวกับลูกค้าและสมาชิกของตน ได้แก่ การจอง สมาชิก การเข้าร่วม บันทึก แบบฟอร์มและใบยินยอม และข้อความระหว่างสถานประกอบการกับลูกค้า สถานประกอบการ (ยิม สตูดิโอ สโมสร โค้ช หรือธุรกิจอื่น เรียกว่า “สถานประกอบการ”) เป็นผู้ควบคุมข้อมูลของระเบียนเหล่านั้น กำหนดวัตถุประสงค์การใช้ และต้องมอบประกาศความเป็นส่วนตัวของตนแก่คุณ เราจัดการระเบียนเหล่านั้นตามคำสั่งของสถานประกอบการเท่านั้น"
        ]
       },
       {
        "t": "p",
        "x": "หากคุณขอสิ่งที่เกี่ยวกับระเบียนที่สถานประกอบการเก็บ เราจะส่งคำขอให้สถานประกอบการและช่วยตอบ (ข้อ 16)"
       }
      ]
     },
     {
      "id": "scope",
      "h": "3. นโยบายนี้ครอบคลุมอะไร",
      "blocks": [
       {
        "t": "p",
        "x": "vms.exsportia.com, wba.exsportia.com แอปและระบบหลังบ้านของ Exsportia แอปเช็กอิน หน้าจอง และช่องทางสนับสนุนของ Exsportia นโยบายนี้ใช้กับลูกค้าและผู้เล่น ผู้ปกครอง เจ้าของและพนักงานของสถานประกอบการ โค้ช ผู้เยี่ยมชมเว็บไซต์ ผู้ที่ติดต่อเรา และผู้ที่จองแทนผู้อื่น และไม่แทนที่ประกาศความเป็นส่วนตัวของสถานประกอบการสำหรับข้อมูลที่สถานประกอบการควบคุม"
       }
      ]
     },
     {
      "id": "collect",
      "h": "4. ข้อมูลส่วนบุคคลที่เรารวบรวม",
      "blocks": [
       {
        "t": "table",
        "head": [
         "ประเภท",
         "ตัวอย่าง"
        ],
        "rows": [
         [
          "บัญชีและโปรไฟล์",
          "ชื่อ อีเมล เบอร์โทรศัพท์มือถือ รหัสผ่านหรือข้อมูลลงชื่อเข้าใช้ (หากใช้ Google คือสิ่งที่ Google ส่งให้เรา: ชื่อ อีเมล รูปโปรไฟล์) วันเกิดเมื่อสถานประกอบการต้องการ ภาษา รูปโปรไฟล์"
         ],
         [
          "การจองและการเข้าร่วม",
          "การจอง คลาส สมาชิกและบัตรผ่าน การเช็กอินและการเข้าร่วม การยกเลิก รายชื่อรอ แบบฟอร์มและใบยินยอมที่สถานประกอบการให้กรอก บันทึกที่คุณเพิ่ม"
         ],
         [
          "ข้อมูลสถานประกอบการและธุรกิจ",
          "ชื่อธุรกิจ ผู้ติดต่อ บัญชีและบทบาทของพนักงาน รายละเอียดสถานประกอบการ บริการ ราคา ข้อมูลบัญชีธนาคารหรือการรับเงินเมื่อจำเป็น เอกสารทางธุรกิจ"
         ],
         [
          "การชำระเงินและการเรียกเก็บเงิน",
          "รหัสอ้างอิงการชำระเงิน จำนวนเงิน สถานะ การคืนเงิน รายละเอียดใบแจ้งหนี้และภาษี รายละเอียดบัตรกรอกกับผู้ให้บริการชำระเงิน (Opn Payments, Stripe หรือ PayPal) และเราไม่เก็บไว้"
         ],
         [
          "ข้อความและการสนับสนุน",
          "ข้อความระหว่างคุณกับสถานประกอบการในแพลตฟอร์ม ประกาศที่เราส่งถึงคุณ อีเมลและคำขอสนับสนุน"
         ],
         [
          "ผู้ช่วย AI",
          "สิ่งที่พนักงานพิมพ์หรือพูดกับผู้ช่วย และระเบียนของสถานประกอบการที่ผู้ช่วยค้นหาเพื่อตอบ (ข้อ 7)"
         ],
         [
          "ข้อมูลทางเทคนิค",
          "ที่อยู่ IP ประเภทเบราว์เซอร์และอุปกรณ์ ระบบปฏิบัติการ เวอร์ชันแอป รหัสอุปกรณ์สำหรับการแจ้งเตือนแบบพุช บันทึกการใช้งาน ตำแหน่งโดยประมาณจาก IP หน้าที่เข้าชม รายงานข้อผิดพลาด"
         ],
         [
          "เนื้อหาที่คุณให้",
          "รูปภาพ ความคิดเห็น หรือเนื้อหาอื่นที่คุณอัปโหลด"
         ]
        ]
       },
       {
        "t": "p",
        "x": "โปรดอย่าให้ข้อมูลอ่อนไหว (สุขภาพ ชีวมิติ ศาสนา การเมือง หรือประวัติอาชญากรรม) เว้นแต่ฟีเจอร์ขอไว้อย่างชัดเจน สถานประกอบการอาจขอข้อมูลสุขภาพหรือการบาดเจ็บในแบบฟอร์มของตนเอง ซึ่งสถานประกอบการต้องรับผิดชอบในการขอความยินยอมจากคุณ เมื่อเราประมวลผลข้อมูลอ่อนไหวให้สถานประกอบการ เราใช้มาตรการเพิ่มเติมและอาศัยความยินยอมโดยชัดแจ้ง"
       }
      ]
     },
     {
      "id": "sources",
      "h": "5. เราได้ข้อมูลมาจากไหน",
      "blocks": [
       {
        "t": "p",
        "x": "จากคุณ จากสถานประกอบการที่คุณจองหรือทำงานด้วย จากบุคคลอื่นที่จองหรือเชิญแทนคุณ หรือผู้ปกครอง จาก Google หากคุณเลือก “Continue with Google” จากผู้ให้บริการชำระเงิน จากผู้ให้บริการด้านเทคโนโลยีของเรา และโดยอัตโนมัติเมื่อคุณใช้แพลตฟอร์ม"
       }
      ]
     },
     {
      "id": "why",
      "h": "6. เหตุผลที่เราใช้ข้อมูลและฐานทางกฎหมาย",
      "blocks": [
       {
        "t": "table",
        "head": [
         "วัตถุประสงค์",
         "สิ่งที่เราทำ",
         "ฐานทางกฎหมาย (PDPA)"
        ],
        "rows": [
         [
          "ให้บริการแพลตฟอร์ม",
          "สร้างและจัดการบัญชี รับการจอง สมาชิก และการชำระเงิน เช็กอิน ส่งการยืนยันการจอง การเตือน ใบเสร็จ และประกาศบริการ ให้การสนับสนุน",
          "การปฏิบัติตามสัญญา และขั้นตอนที่คุณร้องขอก่อนทำสัญญา"
         ],
         [
          "ดำเนินงาน รักษาความปลอดภัย และปรับปรุงแพลตฟอร์ม",
          "ให้ระบบทำงานได้ ป้องกันการฉ้อโกงและการใช้ในทางที่ผิด หาและแก้ไขข้อบกพร่อง ทำสถิติรวม",
          "ประโยชน์โดยชอบด้วยกฎหมายของเรา เมื่อไม่ถูกเหนือกว่าด้วยสิทธิของคุณ"
         ],
         [
          "หน้าที่ตามกฎหมายและบัญชี",
          "เก็บบันทึกบัญชีและภาษี ตอบคำขอที่ชอบด้วยกฎหมาย จัดการข้อพิพาทและการเรียกร้อง",
          "หน้าที่ตามกฎหมาย ประโยชน์โดยชอบด้วยกฎหมาย"
         ],
         [
          "ข่าวสารและข้อเสนอ",
          "ส่งการตลาดจากเราหรือ เมื่อได้รับอนุญาต จากสถานประกอบการ คุณยกเลิกการรับได้ในข้อความหรือในการตั้งค่า",
          "ความยินยอมของคุณ"
         ],
         [
          "ข้อมูลอ่อนไหวที่สถานประกอบการขอ",
          "เฉพาะวัตถุประสงค์ที่สถานประกอบการแจ้งคุณเมื่อขอ",
          "ความยินยอมโดยชัดแจ้งของคุณ ซึ่งสถานประกอบการเป็นผู้ขอ"
         ]
        ]
       }
      ]
     },
     {
      "id": "ai",
      "h": "7. ฟีเจอร์ AI",
      "blocks": [
       {
        "t": "p",
        "x": "Exsportia มีฟีเจอร์ AI ซึ่งใช้ผู้ให้บริการโมเดล AI (ข้อ 10) และอธิบายไว้ที่นี่เพื่อให้คุณทราบว่าส่งอะไรไปให้ผู้ให้บริการ"
       },
       {
        "t": "ul",
        "items": [
         "**ผู้ช่วยในระบบหลังบ้าน** ช่วยพนักงานของสถานประกอบการค้นหาข้อมูลและทำงานประจำ สิ่งที่พนักงานพิมพ์หรือพูด และระเบียนของสถานประกอบการที่ผู้ช่วยต้องใช้ตอบ (เช่น การจองหรือชื่อลูกค้า) จะถูกส่งไปยัง Anthropic ผู้ให้บริการโมเดลภาษา หากเปิดฟีเจอร์เสียง เสียงจะถูกส่งไปยัง OpenAI เพื่อถอดความ และข้อความของเสียงตอบจะถูกส่งไปยัง ElevenLabs ผู้ใช้ลบประวัติการสนทนาในผู้ช่วยได้ และประวัติจะถูกลบเมื่อลบบัญชี ลูกค้าไม่ได้สนทนากับผู้ช่วยนี้",
         "**ผู้ช่วยตอบข้อความของสถานประกอบการ** (ข้อ 8.6): ข้อความและบทสนทนาของลูกค้าตามที่อธิบายไว้ในข้อนั้นจะถูกส่งไปยัง Anthropic เพื่อเขียนคำตอบ"
        ]
       },
       {
        "t": "p",
        "x": "เราไม่ใช้ข้อมูลของสถานประกอบการ ข้อความของลูกค้า หรือสิ่งที่พนักงานพิมพ์ เพื่อฝึกโมเดล และไม่อนุญาตให้ผู้ให้บริการ AI ของเราทำเช่นนั้น ผู้ให้บริการประมวลผลข้อมูลเพื่อให้คำตอบเท่านั้น เราส่งเฉพาะสิ่งที่คำถามต้องใช้ ผลลัพธ์ของ AI อาจผิดพลาดได้ สถานประกอบการรับผิดชอบสิ่งที่ตนเปิดใช้ และบุคคลสามารถเข้ามารับช่วงสนทนาได้เสมอ"
       }
      ]
     },
     {
      "id": "messaging",
      "switch": "MESSAGING_CHANNELS",
      "h": "8. ช่องทางข้อความ (WhatsApp, Messenger, Instagram, Telegram, LINE)",
      "blocks": [
       {
        "t": "p",
        "x": "สถานประกอบการสามารถเชื่อมต่อบัญชี WhatsApp Business เพจ Facebook บัญชี Instagram แบบธุรกิจ บอต Telegram และบัญชีทางการ LINE ของตนกับ Exsportia เพื่อให้ทีมงานอ่านและตอบข้อความของลูกค้าในกล่องข้อความร่วมเดียว (Messages) ช่องทางเปิดให้สถานประกอบการเป็นขั้นตอน ข้อนี้มีผลตั้งแต่สถานประกอบการเชื่อมต่อช่องทาง และไม่มีผลก่อนนั้น ขั้นตอนการยกเลิกการเชื่อมต่อหรือขอลบข้อมูลอยู่ที่[หน้าการลบข้อมูล](/th/data-deletion)"
       },
       {
        "t": "h3",
        "x": "8.1 บทบาทของเรา"
       },
       {
        "t": "ul",
        "items": [
         "สถานประกอบการเป็น **ผู้ควบคุมข้อมูล** ของข้อความที่ส่งและรับผ่านช่องทาง และของรายละเอียดลูกค้าในข้อความ เป็นผู้กำหนดวัตถุประสงค์ในการใช้ และต้องมอบประกาศความเป็นส่วนตัวของตนแก่ลูกค้า",
         "บริษัท เอ็ดดูเคชั่น เอไอ กรุ๊ป จำกัด เป็น **ผู้ประมวลผลข้อมูล** ของข้อความเหล่านั้น เราจัดการข้อความเพื่อให้บริการกล่องข้อความตามคำสั่งที่เป็นลายลักษณ์อักษรของสถานประกอบการเท่านั้น",
         "เราเป็น **ผู้ควบคุมข้อมูล** ของรายละเอียดของพนักงานที่เชื่อมต่อช่องทาง (ชื่อ อีเมลที่ทำงาน และ เมื่อสถานประกอบการอนุญาตการเชื่อมต่อด้วยการล็อกอิน Meta รหัสทางเทคนิคที่ Meta ให้แก่แอปของเราสำหรับบุคคลนั้น) และของบันทึกการเชื่อมต่อที่จำเป็นต่อการให้บริการอย่างปลอดภัย (บัญชีที่เชื่อมต่อ สถานะ เวลาที่เชื่อมต่อและยกเลิก บันทึกการส่งและข้อผิดพลาด)"
        ]
       },
       {
        "t": "h3",
        "x": "8.2 วิธีเชื่อมต่อช่องทาง"
       },
       {
        "t": "p",
        "x": "เฉพาะเจ้าของบัญชีสถานประกอบการเท่านั้นที่เชื่อมต่อหรือยกเลิกช่องทางได้ (การตั้งค่า แล้วเลือก ช่องทาง) สถานประกอบการกรอกข้อมูลรับรองของบัญชีหรือแอปของตนกับผู้ให้บริการ (เช่น โทเคนการเข้าถึงและ app secret ของแอป Meta หรือโทเคนบอต Telegram) หรืออนุญาตการเชื่อมต่อผ่านหน้าต่างล็อกอินของ Meta ซึ่งแสดงว่าแอปทำอะไรได้บ้างและให้สถานประกอบการเลือกบัญชีที่จะแบ่งปัน เราตรวจสอบว่าข้อมูลรับรองใช้ได้ด้วยคำขอแบบอ่านอย่างเดียวไปยังผู้ให้บริการ และตั้งค่าการส่งการแจ้งเตือนเมื่อผู้ให้บริการอนุญาต"
       },
       {
        "t": "h3",
        "x": "8.3 สิ่งที่เรารับและเก็บ"
       },
       {
        "t": "ul",
        "items": [
         "**ข้อความ:** ข้อความตัวอักษรที่ลูกค้าส่งถึงบัญชีของสถานประกอบการและคำตอบที่ส่งจากบัญชี พร้อมเวลา และเมื่อผู้ให้บริการรายงาน ความล้มเหลวในการส่ง รูปภาพ วิดีโอ ข้อความเสียง ไฟล์ และสติกเกอร์ไม่ถูกเก็บ แต่แสดงในกล่องข้อความเป็นข้อความแทนสั้น ๆ เช่น [photo] พร้อมคำบรรยายถ้ามี",
         "**รหัสผู้ส่ง:** หมายเลข WhatsApp รหัสผู้ใช้ระดับเพจของ Messenger รหัสระดับ Instagram รหัสแชต Telegram หรือรหัสผู้ใช้ LINE และชื่อที่แสดง ชื่อผู้ใช้ และภาษา เมื่อผู้ให้บริการให้มา พนักงานของสถานประกอบการเชื่อมการสนทนากับระเบียนลูกค้าได้ จากนั้นข้อความต่อ ๆ ไปจากผู้ส่งนั้นในช่องทางนั้นจะปรากฏในบทสนทนาของลูกค้ารายนั้น",
         "**ข้อมูลการเชื่อมต่อ:** รหัสบัญชี WhatsApp Business หมายเลขโทรศัพท์ เพจ Facebook บัญชี Instagram บอต Telegram หรือบัญชี LINE ของสถานประกอบการ ข้อมูลรับรองการเข้าถึง (โทเคนและ app secret) สถานะการเชื่อมต่อ และเวลาที่เชื่อมต่อและยกเลิก",
         "**บันทึกทางเทคนิค:** บันทึกการส่งและข้อผิดพลาด เก็บไว้เพื่อความปลอดภัยและการแก้ไขปัญหา เราไม่เก็บสำเนาการแจ้งเตือนดิบของผู้ให้บริการ"
        ]
       },
       {
        "t": "h3",
        "x": "8.4 สิ่งที่เราไม่ทำ"
       },
       {
        "t": "p",
        "x": "เราไม่ขายข้อมูลนี้ ไม่ใช้เพื่อการโฆษณา ไม่ใช้ข้อความของลูกค้าเพื่อสร้างโปรไฟล์ เพื่อการตลาดของเราเอง หรือเพื่อฝึกหรือประเมินโมเดลการเรียนรู้ของเครื่อง และไม่อนุญาตให้ผู้ให้บริการของเราทำเช่นนั้น เราไม่อ่านข้อความของสถานประกอบการ เว้นแต่สถานประกอบการขอให้ช่วยเหลือ จำเป็นต่อการรักษาความปลอดภัยของบริการ หรือกฎหมายกำหนด เราไม่ส่งข้อความถึงลูกค้าของสถานประกอบการในนามของเราผ่านช่องทาง ข้อความที่ส่งออกเขียนโดยพนักงานของสถานประกอบการ หรือเมื่อสถานประกอบการเปิดใช้ โดยผู้ช่วยตอบข้อความ"
       },
       {
        "t": "h3",
        "x": "8.5 เหตุผลที่เราใช้ข้อมูล"
       },
       {
        "t": "p",
        "x": "เพื่อรับข้อความและแสดงในกล่องข้อความร่วมของสถานประกอบการ ส่งคำตอบที่พนักงานเขียน ใช้งานผู้ช่วยอัตโนมัติของสถานประกอบการหากเปิดใช้ รักษาการเชื่อมต่อให้ทำงานและปลอดภัย แสดงความล้มเหลวในการส่ง และปฏิบัติตามหน้าที่ตามกฎหมาย สำหรับข้อความของลูกค้า ใช้ฐานทางกฎหมายของสถานประกอบการเอง (โดยทั่วไปคือคำขอของลูกค้าหรือสัญญากับสถานประกอบการ) สำหรับรายละเอียดของพนักงานที่เชื่อมต่อและบันทึกการเชื่อมต่อ ฐานของเราคือสัญญากับสถานประกอบการ (มาตรา 24(3) PDPA) และประโยชน์โดยชอบด้วยกฎหมายด้านความปลอดภัย (มาตรา 24(5) PDPA)"
       },
       {
        "t": "h3",
        "x": "8.6 ผู้ช่วย AI ตอบข้อความ (เลือกใช้)"
       },
       {
        "t": "p",
        "x": "สถานประกอบการเปิดผู้ช่วยที่ตอบข้อความลูกค้าแทนได้ ปิดอยู่จนกว่าสถานประกอบการจะเปิด สถานประกอบการกำหนดคำทักทาย กฎ และสิ่งที่ผู้ช่วยทำได้ และผู้ช่วยส่งต่อการสนทนาให้บุคคลเมื่อควรหรือเมื่อบุคคลเข้ารับช่วง ในการเขียนคำตอบ ข้อความของลูกค้า ข้อความล่าสุดของบทสนทนานั้น กฎและคำถามที่พบบ่อยของสถานประกอบการ และสำหรับลูกค้าที่เชื่อมกับระเบียนลูกค้า ข้อมูลการจองของลูกค้าที่จำเป็นต่อการตอบ จะถูกส่งไปยังผู้ให้บริการ AI ของเรา (Anthropic ข้อ 10) ผู้ให้บริการประมวลผลเพื่อสร้างคำตอบเท่านั้น สถานประกอบการรับผิดชอบในการแจ้งลูกค้าว่าผู้ช่วยอัตโนมัติอาจตอบ"
       },
       {
        "t": "h3",
        "x": "8.7 บทบาทของ Meta และผู้ให้บริการอื่น"
       },
       {
        "t": "p",
        "x": "WhatsApp, Messenger และ Instagram เป็นบริการของ Meta Platforms ส่วน Telegram และ LINE เป็นบริการของผู้ให้บริการแต่ละราย ข้อความเดินทางผ่านระบบของผู้ให้บริการ และผู้ให้บริการประมวลผลข้อมูลบนบริการของตนภายใต้ข้อกำหนดและนโยบายความเป็นส่วนตัวของตนเอง (สำหรับ Meta: facebook.com/privacy/policy) ในฐานะผู้ควบคุมข้อมูลอิสระของการประมวลผลนั้น ค่าบริการข้อความ WhatsApp เรียกเก็บโดย Meta จากสถานประกอบการ ไม่ผ่านเรา"
       },
       {
        "t": "h3",
        "x": "8.8 ความปลอดภัย"
       },
       {
        "t": "p",
        "x": "โทเคนการเข้าถึง app secret และข้อมูลรับรองอื่นถูกเก็บแบบเข้ารหัสในที่เก็บความลับ (Google Cloud) ไม่แสดงให้พนักงานเห็น และไม่ส่งกลับไปยังเบราว์เซอร์หลังสถานประกอบการส่งข้อมูล การแจ้งเตือนจาก Meta และ LINE ถูกตรวจสอบด้วยลายเซ็นเข้ารหัส และของ Telegram ตรวจสอบด้วยรหัสลับ ก่อนที่เราจะดำเนินการ ข้อความถูกเก็บในพื้นที่ฐานข้อมูลของสถานประกอบการเอง และการเข้าถึงจำกัดตามบทบาทและสถานประกอบการ พนักงานจึงเห็นเฉพาะข้อความของสถานประกอบการตนเอง"
       },
       {
        "t": "h3",
        "x": "8.9 การเก็บรักษาและการลบ"
       },
       {
        "t": "ul",
        "items": [
         "**ข้อมูลรับรองการเข้าถึง:** ลบทันทีเมื่อสถานประกอบการยกเลิกการเชื่อมต่อช่องทาง และแทนที่ (ลบของเดิม) เมื่อเชื่อมต่อใหม่ หากผู้ให้บริการไม่รับข้อมูลรับรองอีก การเชื่อมต่อจะแสดงว่าต้องตรวจสอบและขอให้เชื่อมต่อใหม่ ข้อมูลรับรองยังอยู่จนกว่าจะเชื่อมต่อใหม่หรือยกเลิก",
         "**ข้อความและระเบียนผู้ติดต่อที่สร้างจากข้อความ:** เก็บตราบที่บัญชีของสถานประกอบการยังใช้งานอยู่ เพราะเป็นระเบียนของสถานประกอบการ และลบหรือทำให้ไม่ระบุตัวตนเมื่อสถานประกอบการปิดบัญชีหรือสั่งลบ หรือเมื่อบุคคลร้องขอ (8.10) กระบวนการลบอัตโนมัติที่อธิบายในหน้าการลบข้อมูลยังไม่ครอบคลุมข้อความที่รับผ่านช่องทางและระเบียนผู้ติดต่อที่สร้างจากข้อความ จนกว่าจะครอบคลุม เราลบหรือทำให้ไม่ระบุตัวตนด้วยตนเอง ภายใน 30 วันหลังสิ้นสุดระยะผ่อนผันเมื่อปิดสถานประกอบการ และภายใน 30 วันนับจากคำขอในกรณีอื่น และยืนยันเป็นลายลักษณ์อักษรว่าทำอะไรไป",
         "**บันทึกทางเทคนิค:** ตามระยะเวลาในข้อ 13",
         "**สิ่งที่เก็บไว้:** รายการทางบัญชี (ข้อ 13) และบันทึกสั้น ๆ ว่ามีการเชื่อมต่อและถูกยกเลิก เพราะกฎหมายกำหนดหรือเพื่อรักษาความปลอดภัยของบริการ"
        ]
       },
       {
        "t": "h3",
        "x": "8.10 สิทธิของคุณ และวิธีให้ลบข้อมูลนี้"
       },
       {
        "t": "p",
        "x": "หากคุณส่งข้อความถึงสถานประกอบการ โปรดติดต่อสถานประกอบการก่อน เพราะเป็นผู้ควบคุมข้อมูล คุณยังส่งอีเมลถึง [info@educationai.group](mailto:info@educationai.group) หัวข้อ “Data deletion” หรือ “Privacy request” พร้อมสถานประกอบการ ช่องทาง และวันที่ที่เกี่ยวข้อง เราส่งต่อคำขอให้สถานประกอบการ และหากเราลบได้โดยชอบด้วยกฎหมายในฐานะผู้ประมวลผลของสถานประกอบการ เราจะลบ เราตอบภายใน 30 วัน ข้อ 16 อธิบายสิทธิของคุณ และ[หน้าการลบข้อมูล](/th/data-deletion) อธิบายแต่ละเส้นทางทีละขั้นตอน Exsportia ไม่ได้รับการแจ้งเตือนอัตโนมัติเมื่อคุณถอนแอปใน Facebook หรือ Instagram หากคุณถอนและต้องการให้เราลบสิ่งที่เราถืออยู่ โปรดส่งอีเมลถึงเรา"
       },
       {
        "t": "h3",
        "x": "8.11 การโอนข้อมูล เด็ก และคุกกี้"
       },
       {
        "t": "p",
        "x": "ข้อความผ่านระบบของผู้ให้บริการ และโฮสติ้งและผู้ประมวลผลช่วงของเราอยู่นอกประเทศไทย ดูข้อ 11 ลูกค้าที่ส่งข้อความถึงสถานประกอบการโดยปกติเป็นผู้ใหญ่ แพลตฟอร์มไม่ได้ออกแบบให้ส่งข้อความถึงเด็กโดยตรง และเราไม่เก็บข้อความจากเด็กโดยตรงโดยรู้เห็น สถานประกอบการที่ส่งข้อความถึงผู้เยาว์ต้องได้รับอำนาจจากผู้ใช้อำนาจปกครองตามมาตรา 19 และ 20 ของ PDPA การเชื่อมต่อช่องทางไม่ตั้งคุกกี้ในเว็บไซต์ MySportia หรือ Exsportia ใด ๆ"
       }
      ]
     },
     {
      "id": "meta",
      "h": "9. Facebook, Meta และ Google",
      "blocks": [
       {
        "t": "p",
        "x": "คุณลงชื่อเข้าใช้ Exsportia ด้วย Facebook ไม่ได้ และแอปและระบบหลังบ้านของ Exsportia ไม่โหลด Meta (Facebook) Pixel หรือปลั๊กอิน Facebook ใด ๆ เจ้าของสถานประกอบการที่เชื่อมต่อช่องทางข้อความของ Meta (ข้อ 8) อาจอนุญาตผ่านหน้าต่างล็อกอินของ Meta เอง ซึ่งเป็นที่เดียวที่การล็อกอินของ Meta ปรากฏ เว็บไซต์การตลาด exsportia.com ใช้แบนเนอร์คุกกี้ หากคุณยอมรับคุกกี้การตลาดที่นั่น เว็บไซต์อาจโหลด Meta Pixel เพื่อวัดผลโฆษณาของเรา หากคุณปฏิเสธ จะไม่โหลด และคุณเปลี่ยนการเลือกได้ทุกเมื่อผ่านการตั้งค่าของแบนเนอร์ แพลตฟอร์มมี “Continue with Google” หากคุณเลือก Google จะแจ้งชื่อ อีเมล และรูปโปรไฟล์ของคุณแก่เรา และ Google จัดการข้อมูลของคุณตามนโยบายความเป็นส่วนตัวของ Google สถานประกอบการอาจลิงก์ไปยังเพจ Facebook หรือ Instagram ของตน การไปตามลิงก์นั้นพาคุณไปยัง Meta ซึ่งมีนโยบายของตนเอง"
       }
      ]
     },
     {
      "id": "share",
      "h": "10. เมื่อใดที่เราแบ่งปันข้อมูล และผู้ประมวลผลช่วงของเรา",
      "blocks": [
       {
        "t": "p",
        "x": "เราไม่ขายข้อมูลส่วนบุคคล เราแบ่งปันเฉพาะเท่าที่จำเป็นตามวัตถุประสงค์ข้างต้น:"
       },
       {
        "t": "ul",
        "items": [
         "กับสถานประกอบการที่คุณจองหรือทำงานด้วย เพื่อให้ดำเนินบริการได้",
         "กับผู้เข้าร่วมคนอื่นเฉพาะเมื่อฟีเจอร์ต้องใช้ (เช่น รายชื่อทีมหรือคำเชิญ) และจำกัดเฉพาะรายละเอียดพื้นฐาน",
         "กับผู้ให้บริการชำระเงิน ธนาคาร และบริการป้องกันการฉ้อโกง",
         "กับผู้ให้บริการในตารางด้านล่าง ซึ่งประมวลผลข้อมูลให้เราตามสัญญา",
         "กับหน่วยงานรัฐ ศาล บริษัทประกัน และที่ปรึกษา เมื่อกฎหมายกำหนดหรือเพื่อปกป้องสิทธิและความปลอดภัย",
         "กับผู้ซื้อหรือผู้สืบทอดของ บริษัท เอ็ดดูเคชั่น เอไอ กรุ๊ป จำกัด หากมีการปรับโครงสร้างหรือขายกิจการ ภายใต้ข้อตกลงรักษาความลับ"
        ]
       },
       {
        "t": "h3",
        "x": "ผู้ประมวลผลช่วงของเรา"
       },
       {
        "t": "table",
        "head": [
         "ผู้ให้บริการ",
         "เพื่ออะไร",
         "ข้อมูลส่วนบุคคลที่เกี่ยวข้อง"
        ],
        "rows": [
         [
          "Google Cloud / Firebase (Google LLC)",
          "ฐานข้อมูล ระบบลงชื่อเข้าใช้ (Firebase Authentication รวมถึง \"Continue with Google\") ที่เก็บไฟล์ และเซิร์ฟเวอร์ที่ใช้รันแพลตฟอร์ม",
          "ข้อมูลบัญชี โปรไฟล์ การจอง สมาชิก ข้อความ และระเบียนของสถานประกอบการ ไฟล์ที่อัปโหลด"
         ],
         [
          "Amazon Web Services",
          "โฮสติ้งของเว็บไซต์และเว็บแอปของเรา",
          "ข้อมูลทางเทคนิคของคำขอ (ที่อยู่ IP เบราว์เซอร์)"
         ],
         [
          "Opn Payments (formerly Omise)",
          "การชำระเงินด้วยบัตรและพร้อมเพย์ เมื่อสถานประกอบการใช้ เราไม่เห็นและไม่เก็บหมายเลขบัตรเต็ม",
          "ชื่อ อีเมล จำนวนเงิน รหัสอ้างอิงการชำระเงิน"
         ],
         [
          "Stripe",
          "การชำระเงินด้วยบัตร เมื่อสถานประกอบการใช้ เราไม่เห็นและไม่เก็บหมายเลขบัตรเต็ม",
          "ชื่อ อีเมล จำนวนเงิน รหัสอ้างอิงการชำระเงิน"
         ],
         [
          "PayPal",
          "การชำระเงิน เมื่อสถานประกอบการใช้",
          "ชื่อ อีเมล จำนวนเงิน รหัสอ้างอิงการชำระเงิน"
         ],
         [
          "OneSignal",
          "การแจ้งเตือนแบบพุชไปยังโทรศัพท์หรือเบราว์เซอร์ของคุณ (เตือนการจองและประกาศ)",
          "รหัสอุปกรณ์ที่เชื่อมกับบัญชีของคุณ"
         ],
         [
          "Vonage",
          "ข้อความ SMS (เช่น รหัสลงชื่อเข้าใช้และประกาศการจอง)",
          "หมายเลขโทรศัพท์มือถือและเนื้อหาข้อความ"
         ],
         [
          "Resend and Google Workspace (Gmail)",
          "การส่งอีเมลของเรา (ใบเสร็จ การยืนยันการจอง คำเชิญ ประกาศ)",
          "ชื่อ ที่อยู่อีเมล และเนื้อหาอีเมล"
         ],
         [
          "Algolia",
          "การค้นหาสถานประกอบการ คลาส และในระบบหลังบ้านคือการค้นหาบุคคล",
          "ชื่อและรายละเอียดที่ปรากฏในผลการค้นหา"
         ],
         [
          "Cloudinary",
          "การจัดเก็บและปรับขนาดรูปภาพ (รูปสถานประกอบการ รูปโปรไฟล์)",
          "รูปภาพที่คุณหรือสถานประกอบการอัปโหลด"
         ],
         [
          "Intuit QuickBooks",
          "การทำบัญชี เฉพาะเมื่อสถานประกอบการหรือเราเชื่อมต่อ",
          "ชื่อลูกค้า รายละเอียดใบแจ้งหนี้และการชำระเงิน"
         ],
         [
          "Google Calendar",
          "การซิงก์ปฏิทิน เฉพาะเมื่อพนักงานเปิดใช้",
          "เวลาและชื่อรายการจองของพนักงานคนนั้น"
         ],
         [
          "Meta Platforms (WhatsApp, Messenger, Instagram)",
          "ตัวช่องทางเอง เฉพาะเมื่อสถานประกอบการเชื่อมต่อ (ข้อ 8)",
          "ข้อความที่ส่งและรับผ่านบัญชีของสถานประกอบการ และรหัสผู้ส่งที่มากับข้อความ Meta ยังประมวลผลข้อมูลนี้เพื่อตนเองภายใต้ข้อกำหนดของ Meta (ข้อ 8)"
         ],
         [
          "Telegram; LINE",
          "ช่องทาง Telegram และ LINE เฉพาะเมื่อสถานประกอบการเชื่อมต่อ (ข้อ 8)",
          "ข้อความที่ส่งและรับผ่านบอตหรือบัญชีทางการของสถานประกอบการ พร้อมรหัสแชตหรือรหัสผู้ใช้ของผู้ส่งและชื่อที่แสดง"
         ],
         [
          "Anthropic",
          "ผู้ให้บริการโมเดล AI เฉพาะเมื่อใช้ผู้ช่วยในระบบหลังบ้านหรือสถานประกอบการเปิดผู้ช่วยตอบข้อความ (ข้อ 7)",
          "สิ่งที่ผู้ใช้พิมพ์หรือถามและระเบียนที่ต้องใช้ตอบ สำหรับผู้ช่วยตอบข้อความคือข้อความของลูกค้าและบทสนทนาล่าสุด กฎของสถานประกอบการ และข้อมูลการจองที่ต้องใช้ตอบ ไม่ใช้ฝึกโมเดล"
         ],
         [
          "Cloudflare",
          "DNS การส่งมอบเนื้อหา ความปลอดภัย และการรับและส่งต่อการแจ้งเตือนจากช่องทางข้อความ",
          "ข้อมูลเครือข่ายและคำขอ รวมถึงที่อยู่ IP"
         ],
         [
          "OpenAI and ElevenLabs",
          "การป้อนเสียงและเสียงตอบของผู้ช่วย AI เฉพาะเมื่อเปิดฟีเจอร์นั้น (ข้อ 7)",
          "เสียงที่บันทึกและข้อความที่ถูกอ่านออกเสียง"
         ],
         [
          "GoHighLevel",
          "บันทึกการขายและการเริ่มใช้งานของเราสำหรับสถานประกอบการที่ติดต่อเรา (ข้อมูลติดต่อทางธุรกิจเท่านั้น ไม่ใช่ลูกค้า)",
          "ชื่อผู้ติดต่อ อีเมล โทรศัพท์ และรายละเอียดของสถานประกอบการ"
         ],
         [
          "Sentry",
          "รายงานข้อผิดพลาดจากแอปของเรา เฉพาะที่เปิดใช้",
          "ข้อมูลข้อผิดพลาดทางเทคนิค (เบราว์เซอร์ หน้า ข้อความข้อผิดพลาด)"
         ],
         [
          "Google Tag Manager",
          "สถิติการใช้งานของระบบหลังบ้าน (โหลดเฉพาะในระบบหลังบ้าน)",
          "หน้าที่เข้าชมและข้อมูลทางเทคนิค"
         ]
        ]
       },
       {
        "t": "p",
        "x": "สถานประกอบการจะได้รับแจ้งล่วงหน้า 30 วันทางอีเมลหรือในระบบหลังบ้านก่อนที่เราจะเพิ่มหรือเปลี่ยนผู้ให้บริการที่ประมวลผลข้อมูลของตน ผู้ให้บริการบางรายใช้เฉพาะเมื่อสถานประกอบการเปิดฟีเจอร์นั้น"
       }
      ]
     },
     {
      "id": "transfers",
      "h": "11. การโอนข้อมูลไปต่างประเทศ",
      "blocks": [
       {
        "t": "p",
        "x": "ผู้ให้บริการของเราอาจประมวลผลข้อมูลในประเทศไทยและประเทศอื่น รวมถึงสหรัฐอเมริกาและสิงคโปร์ เมื่อข้อมูลส่วนบุคคลออกนอกประเทศไทย เราอาศัยมาตรการคุ้มครองตามมาตรา 28 ของ PDPA ได้แก่ ประเทศปลายทางมีมาตรฐานการคุ้มครองที่เพียงพอ การคุ้มครองตามสัญญากับผู้ให้บริการ ความยินยอมของคุณเมื่อเหมาะสม หรือกลไกอื่นที่ชอบด้วยกฎหมาย"
       }
      ]
     },
     {
      "id": "cookies",
      "h": "12. คุกกี้และเทคโนโลยีที่คล้ายกัน",
      "blocks": [
       {
        "t": "p",
        "x": "แอป Exsportia ใช้สิ่งที่เก็บในเบราว์เซอร์ของคุณจำนวนไม่มาก ได้แก่ เซสชันลงชื่อเข้าใช้ ภาษาที่เลือก รายการโปรด และการจองที่เริ่มไว้ ซึ่งจำเป็นต่อการทำงานของแพลตฟอร์ม ผู้ให้บริการชำระเงิน (Opn Payments, Stripe, PayPal) โหลดสคริปต์ของตนในขั้นตอนชำระเงินเพื่อรับชำระเงินอย่างปลอดภัยและป้องกันการฉ้อโกง ระบบหลังบ้านยังโหลด Google Tag Manager เพื่อทำสถิติการใช้งาน เราไม่ใช้คุกกี้โฆษณาในแอป Exsportia คุณล้างข้อมูลที่เก็บได้ในการตั้งค่าเบราว์เซอร์ หากบล็อกสิ่งที่จำเป็น คุณอาจถูกออกจากระบบและบางฟีเจอร์อาจใช้ไม่ได้"
       }
      ]
     },
     {
      "id": "retention",
      "h": "13. เราเก็บข้อมูลนานเท่าใด",
      "blocks": [
       {
        "t": "table",
        "head": [
         "ข้อมูล",
         "ระยะเวลา"
        ],
        "rows": [
         [
          "บัญชี โปรไฟล์ รหัสอุปกรณ์พุช และการลงชื่อเข้าใช้ของคุณ",
          "ตราบที่บัญชีของคุณเปิดอยู่ และลบทันทีเมื่อคุณลบบัญชี (ข้อ 15)"
         ],
         [
          "ข้อความและบันทึกการแจ้งเตือนเกี่ยวกับคุณ",
          "ตราบที่บัญชีเปิดอยู่ และลบเมื่อคุณลบบัญชี"
         ],
         [
          "การเชื่อมต่อช่องทาง และข้อความและผู้ติดต่อที่รับผ่านช่องทาง (WhatsApp, Messenger, Instagram, Telegram, LINE)",
          "ข้อมูลรับรองการเข้าถึงถูกลบทันทีเมื่อสถานประกอบการยกเลิกการเชื่อมต่อช่องทาง ข้อความและระเบียนผู้ติดต่อที่สร้างจากข้อความเป็นระเบียนของสถานประกอบการ เก็บตราบที่บัญชียังใช้งานอยู่ และลบหรือทำให้ไม่ระบุตัวตนภายใน 30 วันหลังการปิดสถานประกอบการหรือคำร้องขอ (ข้อ 8.9)"
         ],
         [
          "ระเบียนที่สถานประกอบการเก็บเกี่ยวกับลูกค้าและสมาชิก",
          "ตามที่สถานประกอบการกำหนด ตราบที่ใช้แพลตฟอร์ม และทำให้ไม่ระบุตัวตน (ลบรายละเอียดส่วนบุคคล) เมื่อคุณลบบัญชี และเมื่อสถานประกอบการปิด"
         ],
         [
          "การจอง การชำระเงิน ใบแจ้งหนี้ และบันทึกทางบัญชีที่คล้ายกัน",
          "อย่างน้อยห้าปีนับจากรอบบัญชีหรือธุรกรรมที่เกี่ยวข้อง และนานกว่านั้นเมื่อหน่วยงานภาษี ข้อพิพาท หรือการเรียกร้องทางกฎหมายกำหนด หลังลบบัญชีจะคงอยู่โดยไม่มีข้อมูลติดต่อของคุณ เท่าที่ระเบียนนั้นเก็บได้โดยไม่ต้องมีข้อมูลดังกล่าว"
         ],
         [
          "หลักฐานว่าคุณขอให้ลบข้อมูล หรือหยุดรับการตลาด",
          "บันทึกสั้น ๆ ที่มีข้อมูลส่วนบุคคลเท่าที่จำเป็น เพื่อให้เราแสดงได้ว่าได้ทำแล้วและจะไม่ติดต่อคุณอีก"
         ],
         [
          "บันทึกการใช้งานและความปลอดภัย",
          "ระยะเวลาจำกัดที่เหมาะกับความปลอดภัยและการแก้ไขปัญหา"
         ]
        ]
       },
       {
        "t": "p",
        "x": "เมื่อไม่จำเป็นต้องใช้ข้อมูลอีก เราจะลบ ทำให้ไม่ระบุตัวตน หรือรวมเป็นสถิติ สำเนาอาจเหลืออยู่ในข้อมูลสำรองของผู้ให้บริการโฮสติ้งจนกว่าจะถูกเขียนทับตามรอบปกติ เราไม่กู้คืนข้อมูลของบัญชีที่ลบแล้วจากข้อมูลสำรองเหล่านั้น"
       }
      ]
     },
     {
      "id": "security",
      "h": "14. ความปลอดภัย",
      "blocks": [
       {
        "t": "p",
        "x": "เราใช้มาตรการทางเทคนิคและการจัดการเพื่อปกป้องข้อมูลส่วนบุคคล ได้แก่ การควบคุมการเข้าถึงและสิทธิ์ตามบทบาท การเชื่อมต่อที่เข้ารหัส ผู้ให้บริการที่ปลอดภัย และการเฝ้าระวัง ไม่มีบริการออนไลน์ใดปลอดภัยโดยสมบูรณ์ หากเกิดการละเมิดข้อมูลส่วนบุคคล เราจะสอบสวนและดำเนินการตามที่ PDPA กำหนด รวมถึงแจ้งสำนักงานคณะกรรมการคุ้มครองข้อมูลส่วนบุคคลและผู้ได้รับผลกระทบเมื่อกฎหมายกำหนด"
       }
      ]
     },
     {
      "id": "deletion",
      "h": "15. การลบบัญชีและข้อมูลของคุณ",
      "blocks": [
       {
        "t": "p",
        "x": "คุณลบบัญชี Exsportia ของคุณเองได้: ลงชื่อเข้าใช้แอปจองของ Exsportia แล้วเปิด **โปรไฟล์ (Profile)** แล้ว เลือก **ลบบัญชี (Delete Account)** การลบมีผลทันทีและไม่สามารถย้อนกลับได้ โดยสรุป: การลงชื่อเข้าใช้ของคุณถูกลบ โปรไฟล์ถูกล้าง การจองในอนาคตถูกยกเลิก ข้อความ การตั้งค่าการแจ้งเตือน และการลงทะเบียนอุปกรณ์ของคุณถูกลบ และรายละเอียดส่วนบุคคลถูกลบออกจากระเบียนของสถานประกอบการที่เชื่อมกับบัญชีของคุณ บันทึกทางบัญชียังคงอยู่ตามข้อ 13 [หน้าการลบข้อมูล](/th/data-deletion) ระบุว่าอะไรถูกลบและอะไรถูกเก็บ สำหรับลูกค้า เจ้าของสถานประกอบการ และพนักงาน และอธิบายวิธีขอทางอีเมล"
       }
      ]
     },
     {
      "id": "rights",
      "h": "16. สิทธิของคุณภายใต้ PDPA",
      "blocks": [
       {
        "t": "p",
        "x": "ภายใต้บังคับของกฎหมาย คุณมีสิทธิ ถอนความยินยอม ขอเข้าถึงและขอสำเนาข้อมูล ขอให้แก้ไขข้อมูล ขอให้ลบ ทำลาย หรือทำให้ไม่ระบุตัวตน ขอให้ระงับการใช้ ขอรับข้อมูลในรูปแบบที่โอนย้ายได้ และคัดค้านการประมวลผลที่อาศัยประโยชน์โดยชอบด้วยกฎหมายหรือการตลาดโดยตรง คุณร้องเรียนต่อสำนักงานคณะกรรมการคุ้มครองข้อมูลส่วนบุคคลได้หากเห็นว่าสิทธิของคุณถูกละเมิด"
       },
       {
        "t": "p",
        "x": "ส่งอีเมลถึง [info@educationai.group](mailto:info@educationai.group) หัวข้อ “Privacy request” พร้อมอีเมลหรือเบอร์โทรของบัญชี และสถานประกอบการที่เกี่ยวข้อง (ถ้ามี) เราอาจขอข้อมูลเพื่อยืนยันตัวตนของคุณ และตอบภายใน 30 วัน หากคำขอเกี่ยวกับระเบียนที่สถานประกอบการควบคุม เราจะส่งต่อให้สถานประกอบการและช่วยตอบ"
       }
      ]
     },
     {
      "id": "children",
      "h": "17. เด็กและผู้เยาว์",
      "blocks": [
       {
        "t": "p",
        "x": "สถานประกอบการใช้แพลตฟอร์มสำหรับกิจกรรมที่มีเด็กเข้าร่วม แพลตฟอร์มไม่ได้มีไว้ให้เด็กอายุต่ำกว่า 13 ปีใช้เพียงลำพัง ผู้ปกครองควรเป็นผู้จองและสร้างบัญชี เมื่อกฎหมายกำหนดให้ต้องได้รับความยินยอมจากผู้ปกครองสำหรับข้อมูลของผู้เยาว์ เราจะขอความยินยอมนั้น และสถานประกอบการที่เก็บข้อมูลเด็กเป็นผู้รับผิดชอบในการได้รับความยินยอมดังกล่าว"
       }
      ]
     },
     {
      "id": "language",
      "h": "18. ภาษา",
      "blocks": [
       {
        "t": "p",
        "x": "นโยบายนี้เผยแพร่เป็นภาษาอังกฤษและภาษาไทย หากไม่ตรงกัน ให้ถือฉบับภาษาอังกฤษเป็นหลัก เว้นแต่ข้อความภาษาไทยให้ความคุ้มครองแก่คุณตาม PDPA มากกว่า ให้ใช้ข้อความภาษาไทยในส่วนนั้น"
       }
      ]
     },
     {
      "id": "changes",
      "h": "19. การเปลี่ยนแปลงนโยบาย",
      "blocks": [
       {
        "t": "p",
        "x": "เราปรับปรุงหน้านี้เมื่อบริการ ผู้ให้บริการ หรือกฎหมายเปลี่ยนแปลง และเปลี่ยนวันที่ด้านบน หากเป็นการเปลี่ยนแปลงสำคัญ เราจะแจ้งผู้ใช้ในแพลตฟอร์มหรือทางอีเมลด้วย"
       }
      ]
     },
     {
      "id": "contact",
      "h": "20. ติดต่อเรา",
      "blocks": [
       {
        "t": "p",
        "x": "บริษัท เอ็ดดูเคชั่น เอไอ กรุ๊ป จำกัด เลขที่ 2/1 หมู่ที่ 6 ตำบลบ่อผุด อำเภอเกาะสมุย จังหวัดสุราษฎร์ธานี 84320 สำนักงานสาขา: เลขที่ 9/493 ซอยลาดปลาเค้า 78 แขวงอนุสาวรีย์ เขตบางเขน กรุงเทพมหานคร เลขทะเบียนนิติบุคคล 0845568020186 อีเมล [info@educationai.group](mailto:info@educationai.group)"
       },
       {
        "t": "p",
        "x": "โปรดอ่านร่วมกับ[ข้อกำหนดของ Exsportia](/th/terms)"
       }
      ]
     }
    ]
   },
   "terms": {
    "title": "ข้อกำหนดและเงื่อนไข (สรุปภาษาไทย)",
    "meta": "บริษัท เอ็ดดูเคชั่น เอไอ กรุ๊ป จำกัด · มีผลตั้งแต่วันที่ 15 ตุลาคม 2569 (ค.ศ. 2026) · เวอร์ชัน 2.0",
    "lead": [
     {
      "t": "p",
      "x": "หน้านี้เป็นสรุปภาษาไทย ไม่ใช่คำแปลฉบับเต็ม ข้อกำหนดและเงื่อนไขฉบับเต็มภาษาอังกฤษอยู่ที่ [Read in English](/terms) และเป็นฉบับที่ใช้เป็นหลัก เว้นแต่สรุปภาษาไทยนี้หรือประกาศความเป็นส่วนตัวภาษาไทยให้สิทธิหรือการคุ้มครองแก่เจ้าของข้อมูลมากกว่าตาม PDPA เรากำลังจัดทำคำแปลภาษาไทยฉบับเต็มร่วมกับที่ปรึกษากฎหมายของเรา"
     }
    ],
    "sections": [
     {
      "id": "who",
      "h": "1. ผู้ให้บริการ",
      "blocks": [
       {
        "t": "p",
        "x": "Exsportia เป็นแบรนด์ซอฟต์แวร์และแพลตฟอร์มของ บริษัท เอ็ดดูเคชั่น เอไอ กรุ๊ป จำกัด (Education AI Group Co., Ltd.) เลขทะเบียนนิติบุคคล 0845568020186 สำนักงานใหญ่ เลขที่ 2/1 หมู่ที่ 6 ตำบลบ่อผุด อำเภอเกาะสมุย จังหวัดสุราษฎร์ธานี 84320 สำนักงานสาขา เลขที่ 9/493 ซอยลาดปลาเค้า 78 แขวงอนุสาวรีย์ เขตบางเขน กรุงเทพมหานคร บริษัทเป็นนิติบุคคลเพียงรายเดียวที่อยู่เบื้องหลัง Exsportia และ MySportia ติดต่อ [info@educationai.group](mailto:info@educationai.group)"
       }
      ]
     },
     {
      "id": "what",
      "h": "2. ข้อกำหนดนี้คืออะไร",
      "blocks": [
       {
        "t": "p",
        "x": "ข้อกำหนดนี้ใช้เมื่อคุณสร้างบัญชี จอง หรือใช้ Exsportia แพลตฟอร์มเป็นเทคโนโลยีและตัวกลางที่ช่วยให้ผู้คนค้นหา จอง และบริหารจัดการกิจกรรมกีฬา ฟิตเนส และสุขภาพ สถานประกอบการ (“Host”) ไม่ใช่ Exsportia เป็นผู้รับผิดชอบกิจกรรม สถานที่ และบริการที่ตนเสนอ การจองก่อให้เกิดสัญญาสำหรับบริการระหว่างผู้เล่นกับ Host ภายใต้เงื่อนไขของ Host และกฎหมายที่บังคับ"
       }
      ]
     },
     {
      "id": "accounts",
      "h": "3. บัญชีและการจอง",
      "blocks": [
       {
        "t": "p",
        "x": "ให้ข้อมูลที่ถูกต้องและรักษาข้อมูลลงชื่อเข้าใช้เป็นความลับ การจองยืนยันเมื่อแพลตฟอร์มหรือ Host ยืนยันอย่างชัดเจนเท่านั้น ราคา ค่าธรรมเนียม และเงื่อนไขการยกเลิกควรแสดงก่อนชำระเงิน ในขั้นตอนชำระเงิน คุณจะเห็นข้อกำหนดนี้ นโยบายความเป็นส่วนตัว และนโยบายการยกเลิกของ Host และยืนยันว่ายอมรับก่อนชำระเงิน แต่ละ Host ต้องเผยแพร่นโยบายการยกเลิกและการคืนเงินที่ชัดเจน ซึ่งใช้กับการจอง เว้นแต่กฎหมายคุ้มครองผู้บริโภคที่บังคับให้สิทธิมากกว่า"
       }
      ]
     },
     {
      "id": "rules",
      "h": "4. กฎ",
      "blocks": [
       {
        "t": "p",
        "x": "ผู้เล่นใช้สถานที่และอุปกรณ์อย่างรับผิดชอบ ทำตามกฎและคำแนะนำด้านความปลอดภัยของ Host และตัดสินใจเองว่ากิจกรรมเหมาะกับตนหรือไม่ Host ต้องให้ข้อมูลที่ถูกต้อง ปฏิบัติตามกฎหมายผู้บริโภค ภาษี ความปลอดภัย การออกใบอนุญาต ความเป็นส่วนตัว และการโฆษณา และในฐานะผู้ควบคุมข้อมูลลูกค้าของตน ต้องมอบประกาศความเป็นส่วนตัวแก่ลูกค้าและมีฐานทางกฎหมายสำหรับข้อมูลที่เก็บ ห้ามใช้แพลตฟอร์มในทางที่ผิดกฎหมาย ฉ้อโกง ส่งสแปม ละเมิดสิทธิ์ ดึงข้อมูลด้วยระบบอัตโนมัติโดยไม่ได้รับอนุญาต หรือสร้างผลิตภัณฑ์คู่แข่ง"
       }
      ]
     },
     {
      "id": "ai",
      "h": "5. ผู้ช่วย AI และบริการของบุคคลที่สาม",
      "blocks": [
       {
        "t": "p",
        "x": "ระบบหลังบ้านมีผู้ช่วย AI สำหรับพนักงานของ Host และ Host เปิดผู้ช่วยตอบข้อความได้ (ข้อ 5A) คำตอบอาจผิดพลาดและไม่ใช่คำแนะนำทางวิชาชีพ พนักงานที่ใช้รับผิดชอบในการตรวจสอบ บริการของบุคคลที่สาม เช่น ผู้ให้บริการชำระเงิน การลงชื่อเข้าใช้ด้วย Google อีเมลและ SMS ใช้ภายใต้ข้อกำหนดของตนเอง"
       }
      ]
     },
     {
      "id": "messaging",
      "switch": "MESSAGING_CHANNELS",
      "h": "5A. ช่องทางข้อความ (ข้อ 13A ฉบับภาษาอังกฤษ)",
      "blocks": [
       {
        "t": "p",
        "x": "Host เชื่อมต่อบัญชี WhatsApp Business เพจ Facebook บัญชี Instagram แบบธุรกิจ บอต Telegram และบัญชีทางการ LINE ของตนเอง (“ช่องทาง”) เพื่อให้ทีมงานตอบข้อความของลูกค้าในกล่องข้อความเดียว และหาก Host เปิดใช้ เพื่อให้ผู้ช่วยตอบข้อความแทน ช่องทางเปิดให้ใช้เป็นขั้นตอน และเฉพาะเจ้าของบัญชี Host เท่านั้นที่เชื่อมต่อหรือยกเลิกได้"
       },
       {
        "t": "p",
        "x": "บทบาท: Host เป็นผู้ควบคุมข้อมูล และบริษัทเป็นผู้ประมวลผลข้อมูลของข้อความและรายละเอียดลูกค้าในข้อความ บริษัทเป็นผู้ควบคุมข้อมูลเฉพาะรายละเอียดของพนักงานที่เชื่อมต่อช่องทางและบันทึกการเชื่อมต่อ"
       },
       {
        "t": "p",
        "x": "ผู้ให้บริการช่องทางเป็นของ Host เอง: แต่ละช่องทางให้บริการโดยผู้ให้บริการ (Meta Platforms สำหรับ WhatsApp, Messenger, Instagram; Telegram; LINE) ตามข้อกำหนดของผู้ให้บริการเอง ซึ่ง Host ยอมรับกับผู้ให้บริการโดยตรง บริษัทไม่ใช่คู่สัญญา Host รับผิดชอบ: การมีบัญชี แอป และการอนุมัติที่ผู้ให้บริการกำหนด และรักษาข้อมูลรับรองให้ถูกต้องและเป็นความลับ การปฏิบัติตามข้อกำหนดและนโยบายของผู้ให้บริการ (รวมถึง Meta Platform Terms ข้อกำหนดและแนวทางข้อความของ WhatsApp Business เรื่องการขอความยินยอมก่อนส่ง หน้าต่างตอบกลับ 24 ชั่วโมง เนื้อหาต้องห้าม และข้อความที่ไม่ได้ร้องขอ) ค่าบริการที่ผู้ให้บริการเรียกเก็บจาก Host โดยตรงไม่ผ่านบริษัท การมีฐานทางกฎหมายในการส่งข้อความหาลูกค้าและประมวลผลข้อความ และการแจ้งลูกค้า และการยกเลิกการเชื่อมต่อทันทีเมื่อผู้ที่รู้ข้อมูลรับรองออกจากงาน"
       },
       {
        "t": "p",
        "x": "สิ่งที่บริษัททำ: รับการแจ้งเตือนจากผู้ให้บริการและตรวจสอบลายเซ็นหรือรหัสลับ เก็บข้อความและรหัสระบุผู้ส่ง แสดงให้พนักงานที่ได้รับอนุญาต และส่งคำตอบที่พนักงาน (หรือผู้ช่วย) เขียน เก็บข้อมูลรับรองแบบเข้ารหัส ไม่แสดงให้พนักงานเห็น และลบทันทีเมื่อ Host ยกเลิกการเชื่อมต่อ บริษัทไม่ขายข้อความ ไม่ใช้เพื่อโฆษณาหรือการตลาดของตนเอง และไม่ใช้เพื่อฝึกโมเดล"
       },
       {
        "t": "p",
        "x": "ผู้ช่วย AI ตอบข้อความ: เลือกใช้ ปิดอยู่จนกว่า Host จะเปิด ผลลัพธ์ของ AI อาจผิดพลาดได้ Host รับผิดชอบการตั้งค่า การแจ้งลูกค้าว่าผู้ช่วยอัตโนมัติอาจตอบ และการติดตามและรับช่วงสนทนา"
       },
       {
        "t": "p",
        "x": "ข้อจำกัด: ช่องทางขึ้นอยู่กับผู้ให้บริการ ผู้ให้บริการอาจปฏิเสธ ล่าช้า จำกัด ระงับ หรือยุติช่องทาง หรือเปลี่ยนกฎ และข้อความอาจส่งไม่สำเร็จ เราไม่รับรองการส่งถึงหรือความพร้อมใช้งานผ่านช่องทาง การยกเลิกการเชื่อมต่อลบข้อมูลรับรองทันที ข้อความที่รับแล้วยังเป็นระเบียนของ Host จนกว่าจะลบตามที่[หน้าการลบข้อมูล](/th/data-deletion) อธิบาย"
       }
      ]
     },
     {
      "id": "liability",
      "h": "6. ความรับผิดและกฎหมายที่ใช้บังคับ",
      "blocks": [
       {
        "t": "p",
        "x": "แพลตฟอร์มให้บริการตามสภาพ “as is” กีฬาและฟิตเนสมีความเสี่ยงต่อการบาดเจ็บ คุณตัดสินใจเองว่าจะเข้าร่วมหรือไม่ ภายใต้ขอบเขตที่กฎหมายอนุญาต บริษัท เอ็ดดูเคชั่น เอไอ กรุ๊ป จำกัด ไม่รับผิดต่อความเสียหายทางอ้อมหรือต่อเนื่อง และความรับผิดรวมต่อคุณจำกัดไว้ที่จำนวนที่สูงกว่าระหว่างยอดที่คุณชำระให้เราโดยตรงใน 12 เดือน หรือ 5,000 บาท ซึ่งไม่ใช้กับความรับผิดที่กฎหมายไม่ให้จำกัด ข้อกำหนดนี้อยู่ภายใต้กฎหมายของราชอาณาจักรไทย และศาลไทยมีเขตอำนาจ ภายใต้บังคับของกฎหมายคุ้มครองผู้บริโภค"
       }
      ]
     },
     {
      "id": "delete",
      "h": "7. การลบบัญชี",
      "blocks": [
       {
        "t": "p",
        "x": "คุณหยุดใช้แพลตฟอร์มได้ทุกเมื่อ และลบบัญชีของคุณเองได้ตามที่อธิบายใน[หน้าการลบข้อมูล](/th/data-deletion) การลบแอปเพียงอย่างเดียวไม่ลบบัญชีของคุณ วิธีที่เราจัดการข้อมูลส่วนบุคคลอยู่ใน[นโยบายความเป็นส่วนตัว](/th/privacy)"
       }
      ]
     }
    ]
   },
   "deletion": {
    "title": "วิธีลบข้อมูลของคุณ",
    "lead": [
     {
      "t": "p",
      "x": "Exsportia เป็นแบรนด์และแพลตฟอร์มของ บริษัท เอ็ดดูเคชั่น เอไอ กรุ๊ป จำกัด (Education AI Group Co., Ltd.) เลขทะเบียนนิติบุคคล 0845568020186 แพลตฟอร์มเดียวกันให้บริการในชื่อ MySportia ด้วย และหน้านี้ครอบคลุมทั้งสองแบรนด์ หน้านี้อธิบายวิธีให้ลบข้อมูลของคุณ รวมถึงข้อมูลที่มาจาก Meta (Facebook, Instagram, WhatsApp) Telegram หรือ LINE วิธีที่เราจัดการข้อมูลโดยทั่วไปอยู่ใน[นโยบายความเป็นส่วนตัว](/th/privacy) ฉบับภาษาอังกฤษ: [Read in English](/data-deletion)"
     },
     {
      "t": "h3",
      "x": "สรุปสั้น ๆ"
     },
     {
      "t": "ul",
      "items": [
       "**หากต้องการยกเลิกการเชื่อมต่อช่องทาง:** ลงชื่อเข้าใช้ในฐานะเจ้าของสถานประกอบการ เปิด **การตั้งค่า (Settings)** แล้วเลือก **ช่องทาง (Channels)** และคลิก **ยกเลิกการเชื่อมต่อ (Disconnect)** เราลบโทเคนการเข้าถึงที่เก็บไว้ทันที",
       "**หากต้องการลบบัญชีของคุณเอง:** ลงชื่อเข้าใช้แอปจองของ Exsportia แล้วเปิด **โปรไฟล์ (Profile)** แล้ว เลือก **ลบบัญชี (Delete Account)** (ลูกค้า) หรือ ในระบบหลังบ้านเปิด **โปรไฟล์ (Profile)** แล้วเลือก **ลบบัญชีของฉัน (Delete my account)** (พนักงาน) มีผลทันที",
       "**หากต้องการให้ลบข้อมูลอื่น:** ส่งอีเมลถึง [info@educationai.group](mailto:info@educationai.group) เราตอบภายใน 30 วันและแจ้งว่าอะไรถูกลบและอะไรถูกเก็บ",
       "Exsportia ไม่ได้รับการแจ้งเตือนอัตโนมัติเมื่อคุณถอนแอปของเราใน Facebook หรือ Instagram หากคุณถอนแล้ว หรือต้องการให้เราลบสิ่งที่เราถืออยู่เกี่ยวกับคุณ โปรดส่งอีเมลถึงเรา"
      ]
     }
    ],
    "sections": [
     {
      "id": "who",
      "h": "1. หน้านี้สำหรับใคร",
      "blocks": [
       {
        "t": "ul",
        "items": [
         "สถานประกอบการที่เชื่อมต่อบัญชี WhatsApp, Messenger, Instagram, Telegram หรือ LINE และต้องการยกเลิกการเชื่อมต่อหรือปิดบัญชี (ข้อ 3 และ 4)",
         "ผู้ที่ส่งข้อความถึงสถานประกอบการที่ใช้แพลตฟอร์มและต้องการให้ลบข้อความเหล่านั้น (ข้อ 5)",
         "ผู้ที่มีบัญชี Exsportia หรือ MySportia หรือถอนแอปของเราใน Facebook หรือ Instagram หรือเพียงต้องการให้เราลบสิ่งที่เราถืออยู่เกี่ยวกับตน (ข้อ 6 และ 7)"
        ]
       }
      ]
     },
     {
      "id": "roles",
      "h": "2. ใครรับผิดชอบอะไร",
      "blocks": [
       {
        "t": "p",
        "x": "สถานประกอบการที่ใช้แพลตฟอร์มเป็นผู้ควบคุมข้อมูลของข้อความของลูกค้าและรายละเอียดลูกค้าในข้อความ เป็นผู้กำหนดว่าจะเก็บเพราะเหตุใดและนานเท่าใด บริษัท เอ็ดดูเคชั่น เอไอ กรุ๊ป จำกัด เป็นผู้ประมวลผลข้อมูลของสถานประกอบการ เราเก็บข้อความและแสดงในกล่องข้อความของสถานประกอบการตามคำสั่งของสถานประกอบการ"
       },
       {
        "t": "p",
        "x": "เราเป็นผู้ควบคุมข้อมูลของบัญชีของผู้ที่ลงชื่อเข้าใช้ (เช่น เจ้าของและพนักงานของสถานประกอบการ และลูกค้าที่มีบัญชี) และของบันทึกการเชื่อมต่อที่จำเป็นต่อการให้บริการอย่างปลอดภัย ด้วยเหตุนี้ เส้นทางที่ถูกต้องจึงขึ้นอยู่กับว่าคุณเป็นใคร ข้อ 3 ถึง 7 จะพาคุณไปตามเส้นทางนั้น"
       }
      ]
     },
     {
      "id": "channels-disconnect",
      "switch": "MESSAGING_CHANNELS",
      "h": "3. คุณเป็นสถานประกอบการและต้องการยกเลิกการเชื่อมต่อช่องทาง",
      "blocks": [
       {
        "t": "ol",
        "items": [
         "ลงชื่อเข้าใช้ระบบหลังบ้านของคุณ (the Exsportia back office at vms.exsportia.com) ในฐานะเจ้าของสถานประกอบการ เฉพาะเจ้าของเท่านั้นที่เชื่อมต่อหรือยกเลิกช่องทางได้",
         "เปิด **การตั้งค่า (Settings)** แล้วเลือก **ช่องทาง (Channels)**",
         "หาช่องทาง คลิก **ยกเลิกการเชื่อมต่อ (Disconnect)** แล้วยืนยัน"
        ]
       },
       {
        "t": "p",
        "x": "**สิ่งที่เกิดขึ้นทันที** โทเคนการเข้าถึงและข้อมูลรับรองอื่นที่เราถือไว้สำหรับช่องทางนั้นถูกลบออกจากที่เก็บความลับแบบเข้ารหัสของเรา หากเราตั้งค่าการส่งการแจ้งเตือนกับผู้ให้บริการไว้ เราแจ้งผู้ให้บริการให้หยุดส่ง (เราไม่แตะต้องหากยังมีการเชื่อมต่ออื่นใช้เพจหรือบัญชีเดียวกัน) ช่องทางแสดงว่าไม่ได้เชื่อมต่อ และคำตอบที่ยังรอส่งจะล้มเหลวและไม่ถูกส่งภายหลัง"
       },
       {
        "t": "p",
        "x": "**สิ่งที่ยังอยู่** ข้อความที่รับไว้แล้วยังอยู่ในประวัติกล่องข้อความของคุณในฐานะบันทึกทางธุรกิจ จนกว่าคุณจะขอให้ลบหรือปิดบัญชี (ข้อ 4 และ 8)"
       },
       {
        "t": "p",
        "x": "โปรดถอนแอปของเราใน Meta ด้วย เพื่อให้ Meta หยุดแบ่งปันข้อมูลกับแอป เปิด Meta Business Settings แล้วไปที่ Integrations หาแอปที่คุณใช้เชื่อมต่อแพลตฟอร์มแล้วลบออก สำหรับการเข้าสู่ระบบ Facebook หรือ Instagram ส่วนตัว ให้ใช้การตั้งค่า “Business integrations” หรือ “Apps and websites” ของบัญชีนั้น หากคุณเชื่อมต่อด้วยแอป Meta ของคุณเอง คุณลบแอปนั้นใน Meta developer dashboard ได้ด้วย"
       }
      ]
     },
     {
      "id": "venue",
      "h": "4. คุณเป็นสถานประกอบการและต้องการปิดบัญชี",
      "blocks": [
       {
        "t": "p",
        "x": "ในระบบหลังบ้านนี้ การปิดสถานประกอบการทำทางอีเมล: ส่งอีเมลถึง [info@educationai.group](mailto:info@educationai.group) จากอีเมลบัญชีของเจ้าของ ระบุสถานประกอบการ เราส่งสำเนาข้อมูลของสถานประกอบการตามคำขอ แล้วปิดสถานประกอบการหลังช่วงเวลา 14 วันที่คุณเปลี่ยนใจได้ และลบหรือทำให้ระเบียนไม่ระบุตัวตนตามข้อ 8 ภายใน 30 วันหลังวันปิด เรายังลบหรือทำให้ไม่ระบุตัวตนด้วยตนเองของข้อความที่รับผ่านช่องทางและระเบียนผู้ติดต่อที่สร้างจากข้อความ พร้อมข้อมูลรับรองช่องทางที่ยังถืออยู่ และยืนยันเป็นลายลักษณ์อักษร การปิดด้วยตนเองมีในระบบหลังบ้านของ MySportia และยังไม่มีในระบบนี้"
       }
      ]
     },
     {
      "id": "messaged",
      "h": "5. คุณส่งข้อความถึงสถานประกอบการและต้องการให้ลบข้อความ",
      "blocks": [
       {
        "t": "p",
        "x": "สถานประกอบการเป็นผู้ตัดสินว่าจะเก็บอะไร โปรดติดต่อสถานประกอบการก่อน คุณยังส่งอีเมลถึง [info@educationai.group](mailto:info@educationai.group) โดยระบุ:"
       },
       {
        "t": "ul",
        "items": [
         "สถานประกอบการที่คุณส่งข้อความถึง",
         "ช่องทางและบัญชีที่คุณใช้ส่ง (หมายเลข WhatsApp ชื่อ Messenger ชื่อผู้ใช้ Instagram ชื่อ Telegram หรือ LINE)",
         "ช่วงวันที่โดยประมาณ",
         "วิธีติดต่อคุณ เราอาจขอให้คุณยืนยันว่าบัญชีเป็นของคุณ เช่น โดยเขียนถึงเราจากบัญชีนั้น"
        ]
       },
       {
        "t": "p",
        "x": "เราส่งต่อคำขอของคุณให้สถานประกอบการ หากเราลบข้อความได้โดยชอบด้วยกฎหมายในฐานะผู้ประมวลผลของสถานประกอบการ เราลบด้วยตนเองและแจ้งคุณ เราตอบภายใน 30 วัน"
       }
      ]
     },
     {
      "id": "meta-removed",
      "switch": "MESSAGING_CHANNELS",
      "h": "6. คุณถอนแอปของเราใน Facebook หรือ Instagram หรือต้องการให้เราลบข้อมูลที่เราถืออยู่เกี่ยวกับคุณ",
      "blocks": [
       {
        "t": "p",
        "x": "ส่งอีเมลถึง [info@educationai.group](mailto:info@educationai.group) จากที่อยู่อีเมลของบัญชีคุณ หรือแจ้งบัญชี Facebook, Instagram หรือ WhatsApp ที่เกี่ยวข้อง ภายใน 30 วันเราลบโทเคนการเข้าถึงของ Meta และรหัสที่ Meta ให้แก่เราเกี่ยวกับคุณ ทำเครื่องหมายว่าการเชื่อมต่อใดที่คุณสร้างไว้ถูกยกเลิก และแจ้งคุณด้วยภาษาที่เข้าใจง่ายว่าลบอะไรไป และเก็บอะไรไว้ พร้อมเหตุผล"
       }
      ]
     },
     {
      "id": "account",
      "h": "7. คุณมีบัญชี Exsportia หรือ MySportia",
      "blocks": [
       {
        "t": "h3",
        "x": "ลูกค้า"
       },
       {
        "t": "ol",
        "items": [
         "ลงชื่อเข้าใช้แอปจองของ Exsportia แล้วเปิด **โปรไฟล์ (Profile)**",
         "เลือก **ลบบัญชี (Delete Account)**",
         "อ่านว่าจะเกิดอะไรขึ้นแล้วยืนยัน การลบไม่สามารถย้อนกลับได้"
        ]
       },
       {
        "t": "p",
        "x": "สิ่งที่เกิดขึ้นทันทีเมื่อคุณยืนยัน:"
       },
       {
        "t": "ul",
        "items": [
         "การลงชื่อเข้าใช้ของคุณถูกลบ คุณลงชื่อเข้าใช้ด้วยข้อมูลนั้นอีกไม่ได้",
         "โปรไฟล์ของคุณถูกล้าง: ชื่อ อีเมล โทรศัพท์ วันเกิด เพศ ที่อยู่ และรายละเอียดบัตรประจำตัวถูกลบหรือแทนที่ รูปโปรไฟล์และไฟล์ที่คุณอัปโหลดถูกลบ",
         "การจองในอนาคตของคุณถูกยกเลิก และคุณถูกนำออกจากรายชื่อรอ",
         "ในทุกระเบียนของสถานประกอบการที่เชื่อมกับบัญชีของคุณ รายละเอียดส่วนบุคคล (ชื่อ อีเมล โทรศัพท์ วันเกิด ที่อยู่ รูป ความคิดเห็น ผู้ติดต่อฉุกเฉิน) ถูกลบ และระเบียนแสดงเป็น “Deleted contact”",
         "ข้อความ การตั้งค่าการแจ้งเตือน และการลงทะเบียนอุปกรณ์ของคุณถูกลบ",
         "ชื่อและข้อมูลติดต่อของคุณในการจองที่ผ่านมาถูกแทนที่ด้วย “Deleted customer”"
        ]
       },
       {
        "t": "p",
        "x": "หากคุณลงชื่อเข้าใช้ไม่ได้ ให้ส่งอีเมลถึง [info@educationai.group](mailto:info@educationai.group) จากอีเมลของบัญชี ข้อความที่คุณแลกเปลี่ยนกับสถานประกอบการผ่านช่องทางเป็นระเบียนของสถานประกอบการ และอยู่ในข้อ 5"
       },
       {
        "t": "h3",
        "x": "พนักงาน"
       },
       {
        "t": "ul",
        "items": [
         "**นำพนักงานออกจากสถานประกอบการ:** เจ้าของสถานประกอบการเปิด **ทีม (Team)** และนำบุคคลนั้นออก พนักงานสูญเสียสิทธิ์เข้าถึงสถานประกอบการนั้นเท่านั้น บัญชีและสถานประกอบการอื่นของพวกเขาไม่ได้รับผลกระทบ",
         "**ลบบัญชีพนักงานของคุณเอง:** ในระบบหลังบ้านเปิด **โปรไฟล์ (Profile)** แล้วเลือก **ลบบัญชีของฉัน (Delete my account)** สิทธิ์เข้าถึงของคุณในทุกสถานประกอบการถูกลบ การเชื่อมต่อซิงก์ปฏิทินและประวัติผู้ช่วย AI ของคุณถูกลบ และบัญชีของคุณถูกลบเช่นเดียวกับลูกค้าข้างต้น หากคุณเป็นเจ้าของคนเดียวของสถานประกอบการที่ยังเปิดอยู่ โปรดปิดสถานประกอบการก่อน"
        ]
       },
       {
        "t": "h3",
        "x": "ระเบียนที่สถานประกอบการสร้างเกี่ยวกับคุณ"
       },
       {
        "t": "p",
        "x": "ระเบียนที่สถานประกอบการสร้างเกี่ยวกับคุณโดยไม่เชื่อมกับบัญชีของคุณ (เช่น ลูกค้า walk-in ที่พนักงานบันทึก) ยังอยู่กับสถานประกอบการ เพราะสถานประกอบการเป็นผู้ควบคุมข้อมูล โปรดขอให้สถานประกอบการลบ หรือส่งอีเมลถึงเรา เราจะส่งต่อคำขอให้สถานประกอบการและช่วยตอบภายใน 30 วัน"
       }
      ]
     },
     {
      "id": "table",
      "h": "8. สิ่งที่เราลบ และสิ่งที่เราเก็บไว้",
      "blocks": [
       {
        "t": "table",
        "head": [
         "ข้อมูล",
         "สิ่งที่เกิดขึ้น"
        ],
        "rows": [
         [
          "โทเคนการเข้าถึงและข้อมูลรับรองช่องทางอื่น",
          "ลบทันทีเมื่อสถานประกอบการยกเลิกการเชื่อมต่อช่องทาง และเมื่อปิดบัญชีหรือมีคำขอลบ แทนที่ (ลบของเดิม) หากสถานประกอบการเชื่อมต่อใหม่"
         ],
         [
          "ข้อความและบันทึกการสนทนา",
          "เก็บให้สถานประกอบการตราบที่บัญชียังใช้งาน (เป็นระเบียนของสถานประกอบการ) ลบหรือทำให้ไม่ระบุตัวตนด้วยตนเองเมื่อปิดสถานประกอบการ (ข้อ 4) หรือตามคำขอ (ข้อ 5 และ 6) ภายใน 30 วัน ข้อความของลูกค้าที่ลบบัญชีจะถูกลบพร้อมบัญชี (ข้อ 7)"
         ],
         [
          "ระเบียนผู้ติดต่อจากช่องทาง (ชื่อ ชื่อผู้ใช้ รหัสช่องทาง)",
          "เช่นเดียวกับข้อความ"
         ],
         [
          "บัญชีลูกค้า โปรไฟล์ การแจ้งเตือน และการลงทะเบียนอุปกรณ์",
          "ลบหรือล้างทันทีเมื่อลูกค้าลบบัญชี (ข้อ 7)"
         ],
         [
          "ระเบียนลูกค้าและสมาชิกที่สถานประกอบการเก็บ",
          "ลบรายละเอียดส่วนบุคคลออกจากระเบียนที่เชื่อมกับบัญชีที่ลบ ระเบียนผู้ติดต่อทั้งหมดถูกทำให้ไม่ระบุตัวตนเมื่อสถานประกอบการปิด (ข้อ 4)"
         ],
         [
          "รายการทางบัญชี (การจอง การชำระเงิน ใบแจ้งหนี้ ใบเสร็จ)",
          "เก็บตามระยะเวลาที่กฎหมายกำหนด ซึ่งในประเทศไทยอย่างน้อยห้าปี เป็นบัญชีตามกฎหมาย ดูหมายเหตุด้านล่าง"
         ],
         [
          "บันทึกสั้น ๆ ว่ามีการเชื่อมต่อและถูกยกเลิก บันทึกด้านความปลอดภัยและเทคนิค",
          "เก็บเท่าที่จำเป็นต่อความปลอดภัยและการแก้ไขปัญหา ตามที่นโยบายความเป็นส่วนตัวระบุ"
         ],
         [
          "ข้อมูลสำรอง",
          "ถูกเขียนทับตามรอบสำรองปกติของผู้ให้บริการ เราไม่กู้คืนข้อมูลของบัญชีที่ลบแล้วจากข้อมูลสำรอง"
         ]
        ]
       },
       {
        "t": "ul",
        "items": [
         "การจอง การชำระเงิน การขาย ใบแจ้งหนี้ และบันทึกทางบัญชีที่คล้ายกันถูกเก็บไว้ เพราะกฎหมายกำหนดให้เก็บบันทึกบัญชี (ในประเทศไทยอย่างน้อยห้าปี) เมื่อคุณลบบัญชีของคุณเอง ชื่อและข้อมูลติดต่อของคุณในการจองที่ผ่านมาจะถูกแทนที่ด้วย “Deleted customer” เท่าที่ระเบียนเก็บได้โดยไม่ต้องมีข้อมูลนั้น หากใบกำกับภาษีที่ออกแล้วต้องแสดงผู้ซื้อ จะคงไว้ตามที่ออก",
         "เมื่อสถานประกอบการปิด การขาย การจอง บัตรผ่านที่ขาย ใบแจ้งหนี้ การชำระเงิน และการจ่ายเงินจะคงอยู่ตามเดิม รวมถึงชื่อและข้อมูลติดต่อที่คัดลอกไว้ เพราะเหตุผลทางกฎหมายเดียวกัน โปรไฟล์ของสถานประกอบการเอง (ชื่อ ที่อยู่) ก็ถูกเก็บไว้ด้วย",
         "ระเบียนที่สถานประกอบการสร้างเกี่ยวกับคุณโดยไม่เชื่อมกับบัญชีของคุณยังอยู่กับสถานประกอบการ (หัวข้อ 7)",
         "บันทึกสั้น ๆ ว่าคุณขอให้ลบ โดยมีข้อมูลส่วนบุคคลเท่าที่จำเป็น เพื่อให้เราแสดงได้ว่าได้ทำแล้วและจะไม่ติดต่อคุณอีก",
         "ข้อมูลที่เราต้องเก็บเพื่อจัดการการเรียกร้องทางกฎหมาย ข้อพิพาท การฉ้อโกง หรือเหตุการณ์ด้านความปลอดภัย ตราบเท่าที่ความจำเป็นนั้นยังมีอยู่"
        ]
       },
       {
        "t": "p",
        "x": "เราเก็บบันทึกที่จำเป็นต่อการก่อตั้ง ใช้ หรือต่อสู้สิทธิเรียกร้องทางกฎหมายตราบที่การเรียกร้องนั้นยังมีอยู่ ข้อมูลอื่นทั้งหมดถูกลบ"
       }
      ]
     },
     {
      "id": "channels",
      "switch": "MESSAGING_CHANNELS",
      "h": "9. ข้อมูลจาก Meta (Facebook, Instagram, WhatsApp)",
      "blocks": [
       {
        "t": "p",
        "x": "สถานประกอบการเชื่อมต่อบัญชี WhatsApp Business เพจ Facebook และบัญชี Instagram แบบธุรกิจของตนกับ Exsportia เพื่อให้ทีมงานอ่านและตอบข้อความของลูกค้าในกล่องข้อความเดียว"
       },
       {
        "t": "p",
        "x": "**สิ่งที่เรารับจาก Meta:** ข้อความตัวอักษรที่ส่งถึงบัญชีของสถานประกอบการ หมายเลข WhatsApp ของผู้ส่ง รหัสผู้ใช้ระดับเพจของ Messenger หรือรหัสระดับ Instagram และชื่อที่แสดงหรือชื่อผู้ใช้เมื่อ Meta ให้มา รหัสของบัญชี WhatsApp Business หมายเลขโทรศัพท์ เพจ Facebook และบัญชี Instagram ของสถานประกอบการ โทเคนการเข้าถึงของการเชื่อมต่อ และสถานะว่าคำตอบส่งถึงหรือล้มเหลว รูปภาพ วิดีโอ ข้อความเสียง และไฟล์ไม่ถูกเก็บ แต่แสดงเป็นข้อความแทนสั้น ๆ เช่น [photo]"
       },
       {
        "t": "p",
        "x": "**สิ่งที่เราทำกับข้อมูล:** แสดงข้อความให้ทีมของสถานประกอบการ ส่งคำตอบที่ทีม (หรือผู้ช่วย AI ที่สถานประกอบการเลือกใช้) เขียน และรักษาการเชื่อมต่อให้ทำงานและปลอดภัย เราไม่ขาย ไม่ใช้เพื่อโฆษณา หรือใช้ข้อความของลูกค้าเพื่อการตลาดของเราเองหรือฝึกโมเดล AI"
       },
       {
        "t": "p",
        "x": "**วิธีลบ:** ข้อ 3 ถึง 6 ข้างต้น คุณยังตรวจและถอนแอปที่เชื่อมกับบัญชี Facebook หรือ Instagram ของคุณได้ในการตั้งค่า Apps and websites หรือ Business integrations ของ Meta Meta จัดการข้อมูลบนบริการของตนภายใต้นโยบายความเป็นส่วนตัวของ Meta เอง"
       }
      ]
     },
     {
      "id": "request",
      "h": "10. วิธีส่งคำขอ และสิ่งที่เกิดขึ้นต่อไป",
      "blocks": [
       {
        "t": "ol",
        "items": [
         "ส่งอีเมลถึง [info@educationai.group](mailto:info@educationai.group) หัวข้อ “Data deletion” ระบุสิ่งที่อธิบายในข้อ 5 หรือ 6 และสถานประกอบการและบัญชีที่เกี่ยวข้อง",
         "เรายืนยันว่าได้รับแล้ว และอาจขอให้คุณยืนยันตัวตน",
         "ภายใน 30 วัน เราลบหรือทำให้ไม่ระบุตัวตนเท่าที่ลบได้โดยชอบด้วยกฎหมาย ส่งต่อให้สถานประกอบการในสิ่งที่มีแต่สถานประกอบการตัดสินใจได้ และเขียนถึงคุณว่าลบอะไร เก็บอะไร และเพราะอะไร"
        ]
       },
       {
        "t": "p",
        "x": "คุณร้องเรียนต่อสำนักงานคณะกรรมการคุ้มครองข้อมูลส่วนบุคคลได้ด้วย"
       }
      ]
     },
     {
      "id": "contact",
      "h": "ติดต่อเรา",
      "blocks": [
       {
        "t": "p",
        "x": "บริษัท เอ็ดดูเคชั่น เอไอ กรุ๊ป จำกัด (Education AI Group Co., Ltd.) ผู้ให้บริการ Exsportia และ MySportia เลขทะเบียนนิติบุคคล 0845568020186 สำนักงานใหญ่: เลขที่ 2/1 หมู่ที่ 6 ตำบลบ่อผุด อำเภอเกาะสมุย จังหวัดสุราษฎร์ธานี 84320 สำนักงานสาขา: เลขที่ 9/493 ซอยลาดปลาเค้า 78 แขวงอนุสาวรีย์ เขตบางเขน กรุงเทพมหานคร ความเป็นส่วนตัว การลบข้อมูล และกฎหมาย: [info@educationai.group](mailto:info@educationai.group)"
       }
      ]
     }
    ],
    "meta": "บริษัท เอ็ดดูเคชั่น เอไอ กรุ๊ป จำกัด · มีผลตั้งแต่วันที่ 15 ตุลาคม 2569 (ค.ศ. 2026) · เวอร์ชัน 2.0 · หากข้อความไม่ตรงกัน ให้ถือฉบับภาษาอังกฤษเป็นหลัก"
   }
  }
 }
};
export default LEGAL;
